<template>
  <div>
    <vx-card>
       <img class="" v-bind:src="logoUrl" alt="algolia-logo" />
    <div v-if="firma == 'Murat'">
      <div>
        <div>
          <p>&Ouml;N BİLGİLENDİRME FORMU &nbsp;</p>
        </div>
        <div>
          <p>1. TARAFLAR VE KONU&nbsp;</p>
        </div>
        <div>
          <p>İşbu &Ouml;n Bilgilendirme&nbsp;Formu&rsquo;nun&nbsp;konusu, ALICI ile SATICI arasındaki mesafeli
            s&ouml;zleşmeye ilişkin T&uuml;keticilerin Korunması Hakkındaki Kanun ve Mesafeli S&ouml;zleşmeler
            Y&ouml;netmeliği h&uuml;k&uuml;mleri uyarınca bilgilendirilmesidir. Ayrıca Mesafeli S&ouml;zleşmeler
            Y&ouml;netmeliği uyarınca 5/1 a, d, g ve h maddelerindeki hususlara ilişkin bilgiler işbu &Ouml;n
            bilgilendirme&nbsp;Formu&rsquo;nda&nbsp;yer almaktadır. ALICI &ouml;n bilgilendirme formu ve mesafeli satış
            s&ouml;zleşmesine ilişkin bilgileri &uuml;yeliğinin bağlı olduğu &ldquo;Hesabım&rdquo; sayfasından takip
            edebilecek ve siparişine ilişkin verdiği bilgileri &ldquo;Hesabım&rdquo; sayfasından değiştirebilecektir.
            &Ouml;n bilgilendirme formu ve mesafeli satış s&ouml;zleşmesi www.murattekstil.com.tr tarafından kayıt altına
            alınmakta olup, ALICI dilediği zaman &ldquo;Hesabım&rdquo; sayfasından metinlere ulaşım
            sağlayabilecektir.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>2. TANIMLAR&nbsp;</p>
        </div>
        <div>
          <p>İşbu s&ouml;zleşmenin uygulanmasında ve yorumlanmasında aşağıda yazılı terimler karşılarındaki yazılı
            a&ccedil;ıklamaları ifade edeceklerdir.&nbsp;</p>
        </div>
        <div>
          <p>ALICI          &nbsp;  :Bir&nbsp;mal veya hizmeti ticari veya mesleki olmayan ama&ccedil;larla edinen,
            kullanan veya yararlanan ger&ccedil;ek ya da t&uuml;zel kişiyi,&nbsp;</p>
        </div>
        <div>
          <p>Bakan           &nbsp;  :Ticaret&nbsp;Bakanı&rsquo;nı,&nbsp;</p>
        </div>
        <div>
          <p>Bakanlık       &nbsp; :Ticaret&nbsp;Bakanlığı&rsquo;nı,&nbsp;</p>
        </div>
        <div>
          <p>Murat&nbsp;S&ouml;yler Tekstil Sanayi Ticaret Ltd. Şti.:SATICI&rsquo;lar&rsquo;ın&nbsp;&uuml;r&uuml;n ve
            hizmet sunduğu&nbsp;Platform&rsquo;u&nbsp;sağlayan aracı hizmet sağlayıcısı olan&nbsp;Murat&nbsp;S&ouml;yler
            Tekstil Sanayi Ticaret Ltd.&nbsp;Şti.&nbsp;- &nbsp;</p>
        </div>
        <div>
          <p>Hizmet                     &nbsp;  :Bir&nbsp;&uuml;cret veya menfaat karşılığında yapılan ya da yapılması
            taahh&uuml;t edilen mal sağlama dışındaki her t&uuml;rl&uuml; t&uuml;ketici işleminin konusu,&nbsp;</p>
        </div>
        <div>
          <p>Kanun          &nbsp;  :T&uuml;keticinin&nbsp;Korunması Hakkında Kanun&rsquo;u,&nbsp;</p>
        </div>
        <div>
          <p>Platform       &nbsp;  :&nbsp;Murat&nbsp;S&ouml;yler Tekstil Sanayi Ticaret Ltd. Şti.&nbsp;e ait
            www.murattekstil.com.tr adlı internet sitesini ve mobil uygulamasını,&nbsp;</p>
        </div>
        <div>
          <p>SATICI       &nbsp;  :Kamu&nbsp;t&uuml;zel kişileri de dahil olmak &uuml;zere ticari veya mesleki
            ama&ccedil;larla t&uuml;keticiye mal sunan ya da mal sunanın adına ya da hesabına hareket eden ve
            S&ouml;zleşme&rsquo;nin 6. maddesinde bilgileri bulunan ger&ccedil;ek ve/veya t&uuml;zel kişiyi,&nbsp;</p>
        </div>
        <div>
          <p>Sipariş&nbsp;Veren  :Bir&nbsp;mal veya hizmeti&nbsp;Murat&nbsp;S&ouml;yler Tekstil Sanayi Ticaret Ltd.
            Şti.&nbsp;e ait www.murattekstil.com.tr adlı internet sitesi veya mobil uygulaması &uuml;zerinden talep eden
            ger&ccedil;ek ya da t&uuml;zel kişiyi,&nbsp;</p>
        </div>
        <div>
          <p>S&ouml;zleşme       &nbsp; :SATICI&nbsp;ve ALICI arasında akdedilen işbu&nbsp;S&ouml;zleşme&rsquo;yi,&nbsp;
          </p>
        </div>
        <div>
          <p>Taraflar         &nbsp; :SATICI&nbsp;ve&nbsp;ALICI&rsquo;yı,&nbsp;</p>
        </div>
        <div>
          <p>&Uuml;r&uuml;n veya&nbsp;&Uuml;r&uuml;nler   &nbsp;  :Alışverişe&nbsp;konu olan taşınır eşya, tatil
            ama&ccedil;lı taşınan tekstil &uuml;r&uuml;nleri ile ev dekorasyonu ve benzeri her t&uuml;rl&uuml;
            &uuml;r&uuml;nleri, ifade eder.&nbsp;</p>
        </div>
        <div>
          <p>Y&ouml;netmelik              &nbsp;  :Mesafeli&nbsp;Satışlar Y&ouml;netmeliği&rsquo;ni,&nbsp;</p>
        </div>
        <div>
          <p>3. SATICI BİLGİLERİ&nbsp;</p>
        </div>
        <div>
          <p>Satıcı İsim/Unvanı   &nbsp;  :&nbsp;Murat&nbsp;S&ouml;yler Tekstil Sanayi Ticaret Ltd. Şti. &nbsp;</p>
        </div>
        <div>
          <p>Satıcının A&ccedil;ık&nbsp;Adresi :&nbsp;Ovaak&ccedil;a&nbsp;Merkez Mah. İstanbul Cad. No:567-A/B Osmangazi
            Bursa&nbsp;</p>
        </div>
        <div>
          <p>Satıcının&nbsp;Telefonu      :444&nbsp;7 005&nbsp;</p>
        </div>
        <div>
          <p>Satıcı&nbsp;Mersis&nbsp;No       &nbsp; :           &nbsp;</p>
        </div>
        <div>
          <p>Satıcı E-Posta :           esatis@murattekstil.com&nbsp;</p>
        </div>
        <div>
          <p>Alıcının İade Halinde Malı Satıcıya G&ouml;ndereceği Kargo&nbsp;Şirketi   &nbsp; :           İade&nbsp;kodu
            alındığında tarafınıza bilgilendirilen kargo firmasıyla iadenizi g&ouml;nderebilirsiniz.&nbsp;</p>
        </div>
        <div>
          <p>4. ARACI HİZMET&nbsp;SAĞLAYICI&nbsp;&nbsp;Murat&nbsp;S&ouml;yler Tekstil Sanayi Ticaret Ltd. Şti.&nbsp;&nbsp;
          </p>
        </div>
        <div>
          <p>BİLGİLERİ&nbsp;</p>
        </div>
        <div>
          <p>Aracı Hizmet Sağlayıcı&nbsp;Unvan       &nbsp;  :           Murat&nbsp;S&ouml;yler Tekstil Sanayi Ticaret
            Ltd.&nbsp;Şti.&nbsp;-&nbsp;(&ldquo;Murat&nbsp;S&ouml;yler Tekstil Sanayi Ticaret Ltd. Şti.&rdquo;)&apos;e ait
            [www.murattekstil.com.tr]&nbsp;</p>
        </div>
        <div>
          <p>Aracı Hizmet Sağlayıcı&nbsp;Mersis&nbsp;No &nbsp;  :           &nbsp;</p>
        </div>
        <div>
          <p>Aracı Hizmet Sağlayıcısı A&ccedil;ık&nbsp;Adresi          :Ovaak&ccedil;a&nbsp;Merkez Mah. İstanbul Cad.
            No:567-A/B Osmangazi Bursa&nbsp;</p>
        </div>
        <div>
          <p>Aracı Hizmet Sağlayıcı&nbsp;Numarası   &nbsp; :           444&nbsp;7 005&nbsp;</p>
        </div>
        <div>
          <p>Aracı Hizmet Sağlayıcı E-posta&nbsp;Adresi     &nbsp;  :esatis@murattekstil.com&nbsp;</p>
        </div>
        <div>
          <p>5. S&Ouml;ZLEŞME KONUSU MAL VE HİZMETİN TEMEL NİTELİKLERİ ve FİYATI (KDV&nbsp;DAHİL&nbsp;DEĞİL)&nbsp;</p>
        </div>
        <div>
          <p>5.1. Malın/&Uuml;r&uuml;n/&Uuml;r&uuml;nlerin/Hizmetin temel &ouml;zelliklerini (t&uuml;r&uuml;, miktarı,
            marka/modeli, rengi, adedi)&nbsp;Murat&nbsp;S&ouml;yler Tekstil Sanayi Ticaret Ltd. Şti.&nbsp;ait internet
            sitesinde yer almaktadır. &Uuml;r&uuml;n&uuml;n temel &ouml;zellikleri hem &uuml;r&uuml;n&uuml;n ilanının yer
            aldığı ilgili sayfada, sipariş &ouml;zeti sayfasında ve aşağıda yer almaktadır.&nbsp;</p>
        </div>
        <div>
          <p>5.2. Listelenen ve sitede ilan edilen fiyatlar satış fiyatıdır. İlan edilen fiyatlar ve vaatler
            g&uuml;ncelleme yapılana ve değiştirilene kadar ge&ccedil;erlidir. S&uuml;reli olarak ilan edilen fiyatlar ise
            belirtilen s&uuml;re sonuna kadar ge&ccedil;erlidir.&nbsp;</p>
        </div>
        <div>
          <p>5.3.S&ouml;zleşme konusu mal ya da hizmetin t&uuml;m vergiler d&acirc;hil satış fiyatı aşağıdaki tabloda
            g&ouml;sterilmiştir. Bu birim kar&nbsp;marjları&nbsp;13.06.2022 tarihli fiyat listelerindeki marjlardır.
            Toplam siparişteki miktarın toleransı +/- 10%&apos;dur.&nbsp;</p>
        </div>
        <div>
          <p>&Uuml;r&uuml;n A&ccedil;ıklaması         Adet    Peşin Fiyatı     Ara Toplam
            (KDV&nbsp;Dahil&nbsp;Değil)&nbsp;</p>
        </div>
        <div>
          <p>* www.murattekstil.com.tr internet sitesinin a&ccedil;ık pazar ve/veya diğer butiklerinden eş zamanlı olarak
            ger&ccedil;ekleştirilen alışverişlerde hak kazanılan toplam indirim tutarı, kargo bedeli ve taksit farkı
            tutarı birlikte yukarıdaki tabloda g&ouml;sterilmiştir.&nbsp;</p>
        </div>
        <div>
          <p>Teslimat&nbsp;Adresi       &nbsp;  :           &nbsp;</p>
        </div>
        <div>
          <p>Teslim Edilecek&nbsp;Kişi  :           &nbsp;</p>
        </div>
        <div>
          <p>Satıcının&nbsp;Telefonu   &nbsp;  :           &nbsp;</p>
        </div>
        <div>
          <p>Fatura&nbsp;Adresi           &nbsp;  :           &nbsp;</p>
        </div>
        <div>
          <p>Sipariş&nbsp;Tarihi           &nbsp;  :           &nbsp;</p>
        </div>
        <div>
          <p>İşbu siparişin verilmesi ile alıcı taraf, satın aldığı &uuml;r&uuml;nlerin bedellerinin vadesi hakkında ihtar
            edilmiş olur. Karşı taraf, vade tarihinde borcunu &ouml;demediği takdirde kendisine ek bir ihtar yapılması
            gerekmeksizin temerr&uuml;de d&uuml;şer ve satıcı temerr&uuml;t faizine hak kazanır. (TTK 1530/2)&nbsp;</p>
        </div>
        <div>
          <p>Teslim&nbsp;Şekli            &nbsp;  :Alıcıya&nbsp;Teslim&nbsp;</p>
        </div>
        <div>
          <p>Etiket ve&nbsp;paketleme &nbsp;  :&nbsp;&Ccedil;oklu&nbsp;paketleme.&nbsp;</p>
        </div>
        <div>
          <p>S&Ouml;Z KONUSU &Uuml;R&Uuml;N BEDELİ,&nbsp;Murat&nbsp;S&ouml;yler Tekstil Sanayi Ticaret Ltd.
            Şti.&nbsp;ALICI G&Uuml;VENCESİ KAPSAMINDA SATICI ADINA,&nbsp;Murat&nbsp;S&ouml;yler Tekstil Sanayi Ticaret
            Ltd. Şti.&nbsp;TARAFINDAN ALICI&rsquo;DAN TAHSİL EDİLMEKTEDİR. ALICI MALIN
            BEDELİNİ&nbsp;Murat&nbsp;S&ouml;yler Tekstil Sanayi Ticaret Ltd.&nbsp;Şti.&rsquo;YE&nbsp;&Ouml;DEMEKLE,
            &Uuml;R&Uuml;N BEDELİNİ SATICI&rsquo;YA &Ouml;DEMİŞ SAYILACAK VE BİR DAHA &Ouml;DEME
            Y&Uuml;K&Uuml;ML&Uuml;L&Uuml;Ğ&Uuml; ALTINA GİRMEYECEKTİR. ALICI&rsquo;NIN İLGİLİ MEVZUAT KAPSAMINDA İADE
            HAKLARI SAKLIDIR.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>6. &Ouml;DEME VE TESLİM ŞARTLARI&nbsp;</p>
        </div>
        <div>
          <p>Kargo Hari&ccedil; Toplam &Uuml;r&uuml;n&nbsp;Bedeli   &nbsp; :           &nbsp;</p>
        </div>
        <div>
          <p>Kargo&nbsp;&Uuml;creti                                    &nbsp;  :           &nbsp;</p>
        </div>
        <div>
          <p>Taksit&nbsp;Farkı                                     &nbsp;  :           &nbsp;</p>
        </div>
        <div>
          <p>Toplam Sipariş&nbsp;Bedeli                    &nbsp;  :           &nbsp;</p>
        </div>
        <div>
          <p>Sipariş&nbsp;Tarihi                                   &nbsp;  :           &nbsp;</p>
        </div>
        <div>
          <p>İşbu siparişin verilmesi ile alıcı taraf, satın aldığı &uuml;r&uuml;nlerin bedellerinin vadesi hakkında ihtar
            edilmiş olur. Karşı taraf, vade tarihinde borcunu &ouml;demediği takdirde kendisine ek bir ihtar yapılması
            gerekmeksizin temerr&uuml;de d&uuml;şer ve satıcı temerr&uuml;t faizine hak kazanır. (TTK 1530/2)&nbsp;</p>
        </div>
        <div>
          <p>&Ouml;deme Şekli ve&nbsp;Planı :%50&apos;si işbu s&ouml;zleşmenin tebliğine istinaden peşin ve kalan 50% mal
            tesliminden 60 g&uuml;n sonra&nbsp;&hellip;&hellip;&hellip;...&hellip;&hellip;&hellip;&nbsp;tarihinde&nbsp;TL
            bazında banka havalesiyle peşin &ouml;denecektir.&nbsp;</p>
        </div>
        <div>
          <p>Vadesinde yapılmayan &ouml;demelerde, aylık&nbsp;% 3&nbsp;faiz işletilir.&nbsp;</p>
        </div>
        <div>
          <p>3500 TL ve &uuml;st&uuml; kargolarda Nakliye ve sigorta alıcıya aittir.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>Teslim Şartları &uuml;r&uuml;n sayfasında belirtildiği şekilde uygulanacaktır.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>Teslim Şartları: Alıcıya Teslim&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>Teslim Alacak&nbsp;Kişiler         &nbsp;  : &nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>7. CAYMA HAKKI&nbsp;</p>
        </div>
        <div>
          <p>7.1.ALICI hizmet ifasına ilişkin s&ouml;zleşmelerde s&ouml;zleşmenin kurulduğu g&uuml;nden, mal teslimine
            ilişkin s&ouml;zleşmelerde ise malın kendisine tesliminden itibaren, hi&ccedil;bir gerek&ccedil;e
            g&ouml;stermeksizin 14 (on d&ouml;rt) g&uuml;n i&ccedil;inde cayma hakkını kullanarak mal/hizmeti iade
            edebilir.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>a) Cayma hakkına ilişkin s&uuml;renin hesabında tek sipariş konusu olup ayrı ayrı teslim edilen
            mallarda,&nbsp;ALICI&rsquo;nın&nbsp;veya ALICI tarafından belirlenen &uuml;&ccedil;&uuml;nc&uuml; kişinin son
            malı teslim aldığı g&uuml;n,&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>b) Birden fazla par&ccedil;adan oluşan mallarda,&nbsp;ALICI&rsquo;nın&nbsp;veya ALICI tarafından belirlenen
            &uuml;&ccedil;&uuml;nc&uuml; kişinin son par&ccedil;ayı teslim aldığı g&uuml;n,&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>c) Belirli bir s&uuml;re boyunca malın d&uuml;zenli tesliminin yapıldığı
            s&ouml;zleşmelerde,&nbsp;ALICI&rsquo;nın&nbsp;veya ALICI tarafından belirlenen &uuml;&ccedil;&uuml;nc&uuml;
            kişinin ilk malı teslim aldığı g&uuml;n esas alınır.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>7.2.ALICI, cayma hakkı kullanım
            bildirimini&nbsp;Websitesi&nbsp;&uuml;zerinden&nbsp;SATICI&rsquo;ya&nbsp;ulaştırır.
            SATICI,&nbsp;ALICI&rsquo;nın&nbsp;cayma beyanının kendisine ulaşmasından itibaren 14 (on d&ouml;rt) g&uuml;n
            i&ccedil;inde mal/hizmet bedelini iade etmekle y&uuml;k&uuml;ml&uuml;d&uuml;r.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>7.3. S&ouml;z konusu mal/hizmet bedeli&nbsp;ALICI&rsquo;nın&nbsp;satın alırken kullandığı &ouml;deme aracına
            uygun bir şekilde&nbsp;ALICI&rsquo;ya&nbsp;herhangi bir masraf veya y&uuml;k&uuml;ml&uuml;l&uuml;k getirmeden
            yapılır.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>7.4. ALICI, cayma hakkına ilişkin bildirimi SATICI veya&nbsp;Murat&nbsp;S&ouml;yler Tekstil Sanayi Ticaret
            Ltd.&nbsp;Şti.&rsquo;ye&nbsp;y&ouml;nelttiği andan itibaren, 10 (on) g&uuml;n i&ccedil;inde
            malı&nbsp;SATICI&rsquo;ya&nbsp;geri g&ouml;nderir.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>7.5. ALICI cayma s&uuml;resi i&ccedil;inde malı, işleyişine, teknik &ouml;zelliklerine ve kullanım
            talimatlarına uygun bir şekilde kullandığı takdirde meydana gelen değişiklik ve bozulmalardan sorumlu
            değildir.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>7.6. ALICI iade edeceği mal/hizmeti &ouml;n bilgilendirme formunda
            belirtilen&nbsp;SATICI&rsquo;nın&nbsp;anlaşmalı kargo şirketi ile&nbsp;SATICI&rsquo;ya&nbsp;g&ouml;nderdiği
            s&uuml;rece, iade kargo bedeli&nbsp;SATICI&rsquo;ya&nbsp;aittir. İade
            i&ccedil;in&nbsp;ALICI&rsquo;nın&nbsp;bulunduğu yerde&nbsp;SATICI&rsquo;nın&nbsp;anlaşmalı kargo şirketi
            şubesi bulunmaması halinde ALICI herhangi bir kargo şirketiyle g&ouml;nderebilecektir, bu halde kargo
            bedeli&nbsp;ALICI&rsquo;ya&nbsp;aittir.&nbsp;ALICI&rsquo;nın&nbsp;iade edeceği malı &ouml;n bilgilendirme
            formunda belirtilen&nbsp;SATICI&rsquo;nın&nbsp;anlaşmalı kargo şirketi dışında bir kargo şirketi ile
            g&ouml;ndermesi halinde, iade kargo bedeli ve malın kargo s&uuml;recinde uğrayacağı hasardan SATICI sorumlu
            değildir.&nbsp;</p>
        </div>
        <div>
          <p>T&uuml;keticinin, satıcının belirlediği taşıyıcı dışında başka bir taşıyıcı ile malın g&ouml;nderilmesini
            talep etmesi durumunda, malın ilgili taşıyıcıya tesliminden itibaren oluşabilecek kayıp ya da hasardan satıcı
            sorumlu değildir.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>7.7. Mal ile beraber fatura da mevcut olması halinde, ilgili iade b&ouml;l&uuml;m&uuml; de doldurularak ve
            ALICI tarafından imzalanarak teslim edilmelidir.&nbsp;</p>
        </div>
        <div>
          <p>7.8. Cayma hakkının kullanılmasıyla beraber ALICI ve SATICI arasındaki yan s&ouml;zleşmeler masraf, tazminat
            veya cezai şart &ouml;deme y&uuml;k&uuml;ml&uuml;l&uuml;ğ&uuml; olmaksızın sona erer.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>8. CAYMA HAKKININ KULLANILAMAYACAĞI HALLER&nbsp;</p>
        </div>
        <div>
          <p>8.1. ALICI aşağıdaki s&ouml;zleşmelerde cayma hakkını kullanamaz:&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>a) Fiyatı finansal piyasalardaki dalgalanmalara bağlı olarak değişen ve SATICI
            veya&nbsp;Murat&nbsp;S&ouml;yler Tekstil Sanayi Ticaret Ltd.&nbsp;Şti.&rsquo;İN&nbsp;kontrol&uuml;nde olmayan
            mal veya hizmetlere ilişkin s&ouml;zleşmeler&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>b) T&uuml;keticinin istekleri veya kişisel ihtiya&ccedil;ları doğrultusunda hazırlanan mallara ilişkin
            s&ouml;zleşmeler&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>c) &Ccedil;abuk bozulabilen veya son kullanma tarihi ge&ccedil;ebilecek malların teslimine ilişkin
            s&ouml;zleşmeler&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>&ccedil;) Tesliminden sonra ambalaj, bant, m&uuml;h&uuml;r, paket gibi koruyucu unsurları a&ccedil;ılmış olan
            mallardan; iadesi sağlık ve&nbsp;hijyen&nbsp;a&ccedil;ısından uygun olmayanların teslimine ilişkin
            s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>d) Tesliminden sonra başka &uuml;r&uuml;nlerle karışan ve doğası gereği ayrıştırılması m&uuml;mk&uuml;n
            olmayan mallara ilişkin s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>e) Malın tesliminden sonra ambalaj, bant, m&uuml;h&uuml;r, paket gibi koruyucu unsurları a&ccedil;ılmış
            olması halinde maddi ortamda sunulan kitap, dijital i&ccedil;erik ve bilgisayar sarf malzemelerine ilişkin
            s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>f) Abonelik s&ouml;zleşmesi kapsamında sağlananlar dışında gazete ve dergi gibi s&uuml;reli yayınların
            teslimine ilişkin s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>g) Belirli bir tarihte veya d&ouml;nemde yapılması gereken, konaklama, eşya taşıma, araba kiralama, yiyecek
            i&ccedil;ecek tedariki ve eğlence veya dinlenme amacıyla yapılan boş zamanın değerlendirilmesine ilişkin
            s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>ğ) Elektronik ortamda anında ifa edilen hizmetler ile&nbsp;ALICI&rsquo;ya&nbsp;anında teslim edilen gayri
            maddi mallara ilişkin s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>h) Cayma hakkı s&uuml;resi sona ermeden &ouml;nce,&nbsp;ALICI&rsquo;nın&nbsp;onayı ile ifasına başlanan
            hizmetlere ilişkin s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>S&ouml;zleşmeye konu Mal/Hizmet&apos;in&nbsp;Mesafeli S&ouml;zleşmeler Y&ouml;netmeliği&apos;nin uygulama
            alanı dışında bırakılmış olan (SATICI&rsquo;nın&nbsp;d&uuml;zenli teslimatları
            ile&nbsp;ALICI&rsquo;nın&nbsp;meskenine teslim edilen gıda maddelerinin, i&ccedil;eceklerin ya da diğer
            g&uuml;nl&uuml;k t&uuml;ketim maddeleri ile seyahat, konaklama, lokantacılık, eğlence sekt&ouml;r&uuml; gibi
            alanlarda hizmetler) Mal/Hizmet t&uuml;rlerinden&nbsp;m&uuml;teşekkil olması halinde ALICI ve SATICI
            arasındaki hukuki ilişkiye Mesafeli S&ouml;zleşmeler Y&ouml;netmeliği h&uuml;k&uuml;mleri uygulanamaması
            sebebiyle cayma hakkı kullanılamayacaktır.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>9. GENEL H&Uuml;K&Uuml;MLER&nbsp;</p>
        </div>
        <div>
          <p>9.1. ALICI Platform &uuml;zerinden vereceği siparişlerde tek fatura ile aynı sepet i&ccedil;erisinde sipariş
            verebilecektir. SATICI,&nbsp;ALICI&rsquo;nın&nbsp;vereceği siparişler i&ccedil;in bir adet fatura kesecektir.
            ALICI,&nbsp;Murat&nbsp;S&ouml;yler Tekstil Sanayi Ticaret Ltd. Şti.&nbsp;tarafından kendisine bir adet fatura
            keserek kendisine g&ouml;nderilmesini kabul eder. Ş&uuml;pheye mahal bırakmamak bakımından belirtilmelidir ki,
            SATICI,&nbsp;ALICI&rsquo;nın&nbsp;aldığı &uuml;r&uuml;nlerin teslimatını mevzuattaki yasal s&uuml;re
            i&ccedil;erisinde kalmak koşuluyla farklı zamanlarda ger&ccedil;ekleştirebilecektir.&nbsp;</p>
        </div>
        <div>
          <p>SATICI sattığı &uuml;r&uuml;nleri anlaşmalı kargo firmaları aracılığı
            ile&nbsp;ALICILAR&rsquo;a&nbsp;g&ouml;ndermekte ve teslim ettirmektedir. Kargo
            firmasının&nbsp;ALICI&rsquo;nın&nbsp;bulunduğu yerde şubesi olmaması
            halinde&nbsp;ALICI&rsquo;nın&nbsp;&Uuml;r&uuml;n&rsquo;&uuml; kargo firmasının SATICI tarafından bildirilen
            yakın bir diğer şubesinden teslim alması gerekmektedir. İnternet sitesinde &quot;tahmini teslimat tarihi&quot;
            şeklinde belirtilen &uuml;r&uuml;nlerin, teslimat tarihi tahmini olarak belirtilmiş olup bu ifade herhangi bir
            taahh&uuml;t i&ccedil;ermemektedir. Bu &uuml;r&uuml;nler mevzuatta belirtildiği &uuml;zere en ge&ccedil; 30
            g&uuml;n i&ccedil;erisinde&nbsp;ALICI&rsquo;ya&nbsp;teslim edilecektir.&nbsp;</p>
        </div>
        <div>
          <p>9.2. Genel olarak aksi belirtilmediği s&uuml;rece teslimat masrafları (kargo &uuml;creti
            vb.)&nbsp;ALICI&rsquo;ya&nbsp;aittir.&nbsp;</p>
        </div>
        <div>
          <p>9.3. S&ouml;zleşme konusu &uuml;r&uuml;n, yasal 30 (otuz) g&uuml;nl&uuml;k s&uuml;reyi aşmamak koşulu ile her
            bir &uuml;r&uuml;n i&ccedil;in&nbsp;ALICI&rsquo;nın&nbsp;yerleşim yerinin uzaklığına bağlı olarak yasal
            s&uuml;resi i&ccedil;inde ALICI veya g&ouml;sterdiği adresteki
            kişi/kuruluşa,&nbsp;SATICI&rsquo;nın&nbsp;anlaşmalı olduğu kargo firması tarafından teslim edilir. &nbsp;</p>
        </div>
        <div>
          <p>9.4.İşbu s&ouml;zleşme ile satıcı, sipariş konusu &uuml;r&uuml;nlerini &uuml;retime başlayacak, ham madde
            teminini yapacak ve &uuml;retim planlamasını bu sipariş doğduğunda g&uuml;ncelleyecektir. &nbsp;</p>
        </div>
        <div>
          <p>ALICI, sipariş konusu &uuml;r&uuml;nleri almaktan hi&ccedil;bir koşulda vazge&ccedil;emeyecek, alıcı
            siparişin durumunda ve adetlerinde, modellerde değişiklik yapamayacak s&ouml;zleşmeden d&ouml;nemeyecek, bu
            maddeye aykırı davranması halinde ya da ilerleyen s&uuml;re&ccedil;te siparişin bir kısmını almaktan
            vazge&ccedil;mesi halinde verilen kaparonun iade edilmeyecek ve hi&ccedil;bir şekilde
            geri&nbsp;isteyenemeyecektir. Ayrıca bu durumda, satıcının doğacak t&uuml;m zararlarını ALICI
            karşılayacaktır. &nbsp;</p>
        </div>
        <div>
          <p>9.5. Malın teslimi sonrasında, gizli ayıp haricinde, malda bir eksiklik ya da ayıp bulunması durumunda, alıcı
            15 g&uuml;n i&ccedil;erisinde bu durumu satıcıya bildirecektir. Teslimden itibaren 15 g&uuml;n sonrasında
            teslim edilen &uuml;r&uuml;nler hi&ccedil;bir gerek&ccedil;e ile iade edilemeyecek, gizli ayıp haricinde ayıp,
            hata ihbarında bulunulamayacaktır.&nbsp;</p>
        </div>
        <div>
          <p>9.6.&nbsp;&Uuml;r&uuml;nler&rsquo;in, teslimatı anında&nbsp;ALICI&rsquo;nın&nbsp;bizatihi adresinde
            bulunmaması durumunda, SATICI edimini tam ve eksiksiz olarak yerine getirmiş olarak kabul edilecektir. Adreste
            teslim alacak kimsenin olmaması durumunda kargo firması ile temas kurarak &uuml;r&uuml;nlerin sevkiyatını
            takip etmek&nbsp;ALICI&rsquo;nın&nbsp;sorumluluğu olacaktır. &Uuml;r&uuml;n,&nbsp;ALICI&rsquo;dan&nbsp;başka
            bir kişi/kuruluşa teslim edilecek ise, teslim edilecek kişi/kuruluşun adresinde bulunmamasından veya teslimatı
            kabul etmemesinden SATICI sorumlu tutulamaz. Bu hallerde&nbsp;ALICI&rsquo;nın&nbsp;&Uuml;r&uuml;n&apos;&uuml;
            ge&ccedil; teslim almasından kaynaklanan her t&uuml;rl&uuml; zarar ile &Uuml;r&uuml;n&apos;&uuml;n kargo
            şirketinde beklemiş olması ve/veya kargonun&nbsp;SATICI&apos;ya&nbsp;iade edilmesinden dolayı oluşan
            giderler&nbsp;ALICI&rsquo;ya&nbsp;aittir.&nbsp;</p>
        </div>
        <div>
          <p>9.7. ALICI, &Uuml;r&uuml;n&apos;&uuml; teslim aldığı anda kontrol etmekle ve &uuml;r&uuml;nde kargodan
            kaynaklanan bir sorun g&ouml;rd&uuml;ğ&uuml;nde, &uuml;r&uuml;n&uuml; kabul etmemekle ve kargo firması
            yetkilisine tutanak tutturmakla sorumludur. Aksi halde SATICI sorumluluk kabul etmeyecektir.&nbsp;</p>
        </div>
        <div>
          <p>9.8. ALICI, SATICI tarafından aksi yazılı &ouml;ng&ouml;r&uuml;lmemiş ise, &Uuml;r&uuml;n&apos;&uuml; teslim
            almadan &ouml;nce bedelini tamamen &ouml;demiş olması gerekir. Peşin satışlarda teslimattan &ouml;nce
            &Uuml;r&uuml;n bedeli&nbsp;SATICI&rsquo;ya&nbsp;tamamen &ouml;denmediği, taksitli satışlarda vadesi gelen
            taksit tutarı tediye&nbsp;edilmediği takdirde, SATICI tek taraflı olarak s&ouml;zleşmeyi iptal edebilir ve
            &Uuml;r&uuml;n&apos;&uuml; teslim etmeyebilir. &Uuml;r&uuml;n teslimatı sonrasında herhangi bir sebepten
            dolayı, işlem yapılan kredi kartının ait olduğu banka/finans kuruluşunun &Uuml;r&uuml;n
            bedelini&nbsp;SATICI&apos;ya&nbsp;&ouml;dememesi halinde, &Uuml;r&uuml;n en ge&ccedil; 3 g&uuml;n
            i&ccedil;inde ALICI tarafından t&uuml;m giderleri&nbsp;ALICI&rsquo;ya&nbsp;ait olmak
            &uuml;zere&nbsp;SATICI&apos;ya&nbsp;iade edilir.&nbsp;SATICI&apos;nın&nbsp;iadeyi kabul etmeksizin
            &Uuml;r&uuml;n bedeli alacağını takip&nbsp;dahil&nbsp;diğer t&uuml;m akdi-kanuni hakları ayrıca ve her halde
            saklıdır. Herhangi bir sebeple banka ve/veya finans kuruluşu tarafından başarısız kodu g&ouml;nderilen ancak
            banka ve/veya finans kuruluşu tarafından&nbsp;SATICI&rsquo;ya&nbsp;yapılan &ouml;demelere
            ilişkin&nbsp;SATICI&rsquo;nın&nbsp;herhangi bir sorumluluğu bulunmayacaktır.&nbsp;</p>
        </div>
        <div>
          <p>9.9. &Uuml;r&uuml;n&apos;&uuml;n normal satış/teslimat koşulları dışında olağan&uuml;st&uuml; durumlar (hava
            muhalefeti, yoğun trafik, deprem, sel, yangın gibi) nedeni ile yasal 30 g&uuml;nl&uuml;k s&uuml;re zarfında
            teslim edilememesi halinde SATICI teslimat ile ilgili olarak&nbsp;ALICI&rsquo;yı&nbsp;bilgilendirir. Bu
            durumda ALICI siparişi iptal edebilir, benzer bir &uuml;r&uuml;n sipariş edebilir veya olağan&uuml;st&uuml;
            durum sonuna kadar bekleyebilir. M&uuml;cbir sebep halleri olan&nbsp;yangın,sel, deprem,
            salgın&nbsp;hastalık,doğal&nbsp;afetler kaynaklı işletmede ve tedarik zincirinde işlerin kısmen
            ve&nbsp;tamamiyle&nbsp;yapılamaması halinde teslimat tarihleri revize edilebilir.&nbsp;</p>
        </div>
        <div>
          <p>9.10. Sipariş iptallerinde &uuml;r&uuml;n bedeli tahsil edilmiş ise&nbsp;ALICI&rsquo;ya&nbsp;iade
            edilir.&nbsp;Kredi kartlı &ouml;demelerde iade işlemi de ALICI kredi kartına iade sureti ile yapılır ve
            &Uuml;r&uuml;n tutarı, siparişin ALICI tarafından iptal edilmesinden sonra ilgili bankaya iade edilir; bu
            tutarın Bankaya iadesinden sonra ALICI hesaplarına yansıması tamamen Banka işlem s&uuml;reci ile ilgili
            olduğundan, ALICI olası gecikmeler i&ccedil;in&nbsp;SATICI&rsquo;nın&nbsp;herhangi bir şekilde m&uuml;dahalede
            bulunmasının ve sorumluluk &uuml;stlenmesinin m&uuml;mk&uuml;n olamayacağını şimdiden kabul
            eder.&nbsp;(Bankaların iadeyi ALICI hesabına yansıtma işlemleri genellikle 3 (&uuml;&ccedil;) haftayı
            bulabilmektedir).&nbsp;</p>
        </div>
        <div>
          <p>9.11. SATICI olağan&uuml;st&uuml; durumlar dışında haklı bir nedenle s&ouml;zleşme konusu &uuml;r&uuml;nlerin
            tedarik edilemeyeceğinin anlaşılması halinde durumu &ouml;ğrenmesinden itibaren 3 (&uuml;&ccedil;) g&uuml;n
            i&ccedil;inde&nbsp;ALICI&rsquo;yı&nbsp;bilgilendirerek onayını almak sureti ile eşit kalite ve fiyatta başka
            bir mal/hizmeti tedarik edebilir ve S&ouml;zleşme konusu taahh&uuml;d&uuml;n&uuml; bu suretle yerine getirmiş
            sayılır.&nbsp;ALICI&rsquo;nın&nbsp;onay vermediği hallerde sipariş iptaline ilişkin h&uuml;k&uuml;mler
            uygulanır.&nbsp;</p>
        </div>
        <div>
          <p>10. KİŞİSEL VERİLERİN KORUNMASI, TİCARİ ELEKTRONİK İLETİ VE FİKRİ-SINAİ HAKLAR İLE İLGİLİ KURALLAR
            ŞARTLAR&nbsp;</p>
        </div>
        <div>
          <p>10.1. 6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında kişisel veri olarak
            tanımlanabilecek&nbsp;ALICI&rsquo;ya&nbsp;ait ad,&nbsp;soyad, e-posta adresi, T.C. Kimlik numarası, demografik
            veriler, mali veriler vb. bilgiler;&nbsp;</p>
        </div>
        <div>
          <p>&bull; sipariş almak, &uuml;r&uuml;n ve hizmetleri sunmak, &uuml;r&uuml;n ve hizmetleri geliştirmek,
            sistemsel sorunların &ccedil;&ouml;z&uuml;m&uuml;, &ouml;deme işlemlerini ger&ccedil;ekleştirmek,
            -&ouml;nceden onay verilmesi halinde- siparişler, &uuml;r&uuml;nler ve hizmetler hakkında pazarlama
            faaliyetlerinde kullanılmak,&nbsp;ALICI&rsquo;ya&nbsp;ait bilgilerin g&uuml;ncellenmesinde ve &uuml;yeliklerin
            y&ouml;netimi ve s&uuml;rd&uuml;r&uuml;lmesi ile ALICI ile SATICI arasında kurulan mesafeli satış
            s&ouml;zleşmesi ve sair s&ouml;zleşmelerin ifası amacıyla ve 3. kişilerin teknik, lojistik ve benzeri diğer
            işlevlerinin SATICI tarafından sağlanabilmesi i&ccedil;in yukarıda sayılan
            verileri&nbsp;Murat&nbsp;S&ouml;yler Tekstil Sanayi Ticaret Ltd.
            Şti.&nbsp; ve&nbsp;&uuml;&ccedil;&uuml;nc&uuml; kişi ve/veya kuruluşlar tarafından s&uuml;resiz/s&uuml;reli
            kaydedilebilir, yazılı/manyetik arşivlerde muhafaza edilebilir, kullanılabilir, g&uuml;ncellenebilir,
            paylaşılabilir, transfer olunabilir ve sair suretler ile işlenebilir.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>10.2.&nbsp;ALICILAR&rsquo;a, y&uuml;r&uuml;rl&uuml;kteki mevzuata uygun şekilde, her t&uuml;rl&uuml;
            &uuml;r&uuml;n ve hizmetlere ilişkin tanıtım, reklam, iletişim,&nbsp;promosyon, satış ve pazarlama amacıyla,
            kredi kartı ve &uuml;yelik bilgilendirme, işlem, uygulamaları i&ccedil;in&nbsp;Murat&nbsp;S&ouml;yler Tekstil
            Sanayi Ticaret Ltd. Şti.&nbsp;tarafından SMS/kısa mesaj, anlık bildirim, otomatik arama, bilgisayar, telefon,
            e-posta/mail, faks, diğer elektronik iletişim ara&ccedil;ları ile ticari elektronik iletişimler yapılabilir,
            ALICI kendisine ticari elektronik iletiler g&ouml;nderilmesini kabul etmiştir.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>10.3. ALICI tarafından&nbsp;Platform&rsquo;a&nbsp;girilen bilgilerin ve işlemlerin g&uuml;venliği i&ccedil;in
            gerekli &ouml;nlemler,&nbsp;Murat&nbsp;S&ouml;yler Tekstil Sanayi Ticaret Ltd. Şti. tarafındaki kendi sistem
            altyapısında, bilgi ve işlemin mahiyetine g&ouml;re g&uuml;n&uuml;m&uuml;z teknik imk&acirc;nları
            &ouml;l&ccedil;&uuml;s&uuml;nde alınmıştır. Bununla beraber, s&ouml;z konusu
            bilgiler&nbsp;ALICI&rsquo;ya&nbsp;ait cihazlardan girildiğinden ALICI tarafından korunmaları ve ilgisiz
            kişilerce erişilememesi i&ccedil;in, vir&uuml;s ve benzeri zararlı uygulamalara ilişkin olanlar d&acirc;hil,
            gerekli tedbirlerin alınması sorumluluğu&nbsp;ALICI&rsquo;ya&nbsp;aittir.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>10.4. ALICI,&nbsp;Murat&nbsp;S&ouml;yler Tekstil Sanayi Ticaret Ltd.&nbsp;Şti.&rsquo;de&nbsp;belirtilen
            iletişim kanallarından ulaşarak veri kullanımı-işlenmelerini ve/veya iletişimleri her zaman i&ccedil;in
            durdurulmasını talep edebilir.&nbsp;ALICI&rsquo;nın&nbsp;bu husustaki a&ccedil;ık bildirimine g&ouml;re,
            kişisel veri işlemleri ve/veya tarafına iletişimler yasal azami s&uuml;re i&ccedil;inde durdurulur; ayrıca
            dilerse, hukuken muhafazası gerekenler ve/veya m&uuml;mk&uuml;n olanlar haricindeki bilgileri, veri kayıt
            sisteminden silinir ya da kimliği belli olmayacak bi&ccedil;imde anonim hale getirilir.&nbsp;ALICI isterse
            kişisel verilerinin işlenmesi ile ilgili işlemler, aktarıldığı kişiler, eksik veya yanlış olması halinde
            d&uuml;zeltilmesi, d&uuml;zeltilen bilgilerin ilgili &uuml;&ccedil;&uuml;nc&uuml; kişilere bildirilmesi,
            verilerin silinmesi veya yok edilmesi, otomatik sistemler ile analiz edilmesi sureti ile kendisi aleyhine bir
            sonucun ortaya &ccedil;ıkmasına itiraz, verilerin kanuna aykırı olarak işlenmesi sebebi ile zarara uğrama
            halinde giderilmesi gibi konularda&nbsp;Murat&nbsp;S&ouml;yler Tekstil Sanayi Ticaret Ltd. Şti.&nbsp;&rsquo;e
            her zaman başvurabilir ve bilgi alabilir.&nbsp;S&ouml;z konusu başvurular incelenerek yasal s&uuml;resi
            i&ccedil;erisinde&nbsp;ALICI&rsquo;ya&nbsp;mevzuatta &ouml;ng&ouml;r&uuml;len s&uuml;relerde d&ouml;n&uuml;ş
            yapılacaktır.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>10.5.&nbsp;Platform&rsquo;a&nbsp;ait her t&uuml;rl&uuml; bilgi ve i&ccedil;erik ile bunların
            d&uuml;zenlenmesi,&nbsp;revizyonu&nbsp;ve kısmen/tamamen kullanımı
            konusunda;&nbsp;SATICI&apos;nın&nbsp;anlaşmasına g&ouml;re diğer &uuml;&ccedil;&uuml;nc&uuml; şahıslara ait
            olanlar hari&ccedil;; t&uuml;m fikri-sınai haklar ve m&uuml;lkiyet hakları&nbsp;Murat&nbsp;S&ouml;yler Tekstil
            Sanayi Ticaret Ltd.&nbsp;Şti.&rsquo;ne&nbsp;aittir.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>10.6.&nbsp;Platform&rsquo;dan&nbsp;ulaşılan diğer sitelerde kendilerine ait gizlilik-g&uuml;venlik
            politikaları ve kullanım şartları ge&ccedil;erlidir, oluşabilecek ihtilaflar ile menfi
            neticelerinden&nbsp;Murat&nbsp;S&ouml;yler Tekstil Sanayi Ticaret Ltd. Şti.&nbsp; sorumlu&nbsp;değildir.&nbsp;
          </p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>11. UYUŞMAZLIKLARIN &Ccedil;&Ouml;Z&Uuml;M&Uuml;&nbsp;</p>
        </div>
        <div>
          <p>Yukarıdaki bilgiler uzaktan iletişim ara&ccedil;larına uygun olarak ve iyi niyet ilkeleri
            &ccedil;er&ccedil;evesinde ergin olmayanlar ile ayırtım g&uuml;c&uuml;nden yoksun veya kısıtlı erginleri
            koruyacak şekilde ticari ama&ccedil;larla verilmiştir.&nbsp;</p>
        </div>
        <div>
          <p>11.1. İşbu &Ouml;n Bilgilendirmenin uygulanmasında ve işbu s&ouml;zleşmeden doğacak uyuşmazlıklarda yahut
            &ccedil;ekişmesiz işlerde&nbsp;işlerde&nbsp;Bursa&nbsp;Mahkemeleri ve İcra Daireleri yetkilidir.&nbsp;</p>
        </div>
        <div>
          <p>11.2.İşbu Mesafeli Satış S&ouml;zleşmesi&apos;nin uygulanmasında, Ticaret Bakanlığınca ilan edilen değere
            kadar T&uuml;ketici Hakem Heyetleri ile T&uuml;ketici Mahkemeleri yetkilidir.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>11.3. 6502 Sayılı T&uuml;keticinin Korunması Hakkında Kanun&apos;un 68. maddesinin 1. fıkrasında belirtilen
            alt ve &uuml;st limitler doğrultusunda t&uuml;ketici talepleri hakkında il&ccedil;e/il t&uuml;ketici hakem
            heyetleri yetkilidir.&nbsp;</p>
        </div>
        <div>
          <p>&nbsp;</p>
        </div>
      </div>
    </div>
    <div v-else-if="firma == 'Buldans'">
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 19px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&Ouml;N BİLGİLENDİRME FORMU&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">1. TARAFLAR VE KONU</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">İşbu &Ouml;n Bilgilendirme Formu&rsquo;nun konusu, ALICI ile SATICI
          arasındaki mesafeli s&ouml;zleşmeye ilişkin T&uuml;keticilerin Korunması
          Hakkındaki Kanun ve Mesafeli S&ouml;zleşmeler Y&ouml;netmeliği
          h&uuml;k&uuml;mleri uyarınca bilgilendirilmesidir. Ayrıca Mesafeli
          S&ouml;zleşmeler Y&ouml;netmeliği uyarınca 5/1 a, d, g ve h
          maddelerindeki hususlara ilişkin bilgiler işbu &Ouml;n bilgilendirme
          Formu&rsquo;nda yer almaktadır. ALICI &ouml;n bilgilendirme formu ve
          mesafeli satış s&ouml;zleşmesine ilişkin bilgileri &uuml;yeliğinin bağlı
          olduğu &ldquo;Hesabım&rdquo; sayfasından takip edebilecek ve siparişine
          ilişkin verdiği bilgileri &ldquo;Hesabım&rdquo; sayfasından
          değiştirebilecektir. &Ouml;n bilgilendirme formu ve mesafeli satış
          s&ouml;zleşmesi www.buldans.com.tr tarafından kayıt altına alınmakta
          olup, ALICI dilediği zaman &ldquo;Hesabım&rdquo; sayfasından metinlere
          ulaşım sağlayabilecektir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">2. TANIMLAR</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">İşbu s&ouml;zleşmenin uygulanmasında ve yorumlanmasında aşağıda yazılı
          terimler karşılarındaki yazılı a&ccedil;ıklamaları ifade
          edeceklerdir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">ALICI&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;:Bir mal veya
          hizmeti ticari veya mesleki olmayan ama&ccedil;larla edinen, kullanan
          veya yararlanan ger&ccedil;ek ya da t&uuml;zel kişiyi,</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Bakan&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;&nbsp;:Ticaret Bakanı&rsquo;nı,</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Bakanlık&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;:Ticaret
          Bakanlığı&rsquo;nı,</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC.
          A.Ş&nbsp;:SATICI&rsquo;lar&rsquo;ın &uuml;r&uuml;n ve hizmet sunduğu
          Platform&rsquo;u sağlayan aracı hizmet sağlayıcısı olan D&Ouml;NMEZ EV
          TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş -&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Hizmet&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;:Bir &uuml;cret veya menfaat
          karşılığında yapılan ya da yapılması taahh&uuml;t edilen mal sağlama
          dışındaki her t&uuml;rl&uuml; t&uuml;ketici işleminin konusu,</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Kanun&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;&nbsp;:T&uuml;keticinin Korunması Hakkında Kanun&rsquo;u,</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Platform&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;:D&Ouml;NMEZ EV
          TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş e ait www.buldans.com.tr adlı
          internet sitesini ve mobil uygulamasını,</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">SATICI&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;:Kamu t&uuml;zel kişileri
          de dahil olmak &uuml;zere ticari veya mesleki ama&ccedil;larla
          t&uuml;keticiye mal sunan ya da mal sunanın adına ya da hesabına hareket
          eden ve S&ouml;zleşme&rsquo;nin 6. maddesinde bilgileri bulunan
          ger&ccedil;ek ve/veya t&uuml;zel kişiyi,</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Sipariş Veren&nbsp;&nbsp;:Bir mal veya hizmeti D&Ouml;NMEZ EV TEKSTİLİ
          VE GİYİM SAN. VE TİC. A.Ş e ait www.buldans.com.tr adlı internet sitesi
          veya mobil uygulaması &uuml;zerinden talep eden ger&ccedil;ek ya da
          t&uuml;zel kişiyi,</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">S&ouml;zleşme&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;:SATICI ve ALICI
          arasında akdedilen işbu S&ouml;zleşme&rsquo;yi,</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Taraflar&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;:SATICI ve
          ALICI&rsquo;yı,</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&Uuml;r&uuml;n veya &Uuml;r&uuml;nler&nbsp; &nbsp;
          &nbsp;&nbsp;:Alışverişe konu olan taşınır eşya, tatil ama&ccedil;lı
          taşınan tekstil &uuml;r&uuml;nleri ile ev dekorasyonu ve benzeri her
          t&uuml;rl&uuml; &uuml;r&uuml;nleri, ifade eder.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Y&ouml;netmelik&nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;&nbsp;:Mesafeli Satışlar Y&ouml;netmeliği&rsquo;ni,</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">3. SATICI BİLGİLERİ</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Satıcı İsim/Unvanı&nbsp; &nbsp; &nbsp;&nbsp;:D&Ouml;NMEZ EV TEKSTİLİ VE
          GİYİM SAN. VE TİC. A.Ş&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Satıcının A&ccedil;ık Adresi&nbsp;:Cumhuriyet mah. sanayi cad. no:146
          Buldan Denizli</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Satıcının Telefonu&nbsp; &nbsp; &nbsp;&nbsp;:0258 431 4096</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Satıcı Mersis No&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;:&nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Satıcı E-Posta&nbsp;:&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;buldans@buldans.com.tr</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Alıcının İade Halinde Malı Satıcıya G&ouml;ndereceği Kargo
          Şirketi&nbsp; &nbsp; &nbsp;:&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;İade kodu alındığında tarafınıza bilgilendirilen kargo firmasıyla
          iadenizi g&ouml;nderebilirsiniz.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">4. ARACI HİZMET SAĞLAYICI D&Ouml; D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN.
          VE TİC. A.Ş -BULDAN&rsquo;S BİLGİLERİ</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Aracı Hizmet Sağlayıcı Unvan&nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;&nbsp;:&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;D&Ouml;NMEZ EV
          TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş - (&ldquo;D&Ouml;NMEZ EV TEKSTİLİ VE
          GİYİM SAN. VE TİC. A.Ş &rdquo;)&apos;e ait [www.buldans.com.tr]</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Aracı Hizmet Sağlayıcı Mersis No&nbsp; &nbsp;&nbsp;:&nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Aracı Hizmet Sağlayıcısı A&ccedil;ık Adresi&nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;&nbsp;:Cumhuriyet mah. 82 Sk.Buldan&rsquo;s Blok No:2 Buldan
          Denizli</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Aracı Hizmet Sağlayıcı Numarası&nbsp; &nbsp; &nbsp;:&nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp;+90 0258 431 4096</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Aracı Hizmet Sağlayıcı E-posta Adresi&nbsp; &nbsp; &nbsp;
          &nbsp;&nbsp;:buldans@buldans.com.tr</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">5. S&Ouml;ZLEŞME KONUSU MAL VE HİZMETİN TEMEL NİTELİKLERİ ve FİYATI
          (KDV DAHİL)</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">5.1. Malın/&Uuml;r&uuml;n/&Uuml;r&uuml;nlerin/Hizmetin temel
          &ouml;zelliklerini (t&uuml;r&uuml;, miktarı, marka/modeli, rengi, adedi)
          D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş - Buldan&rsquo;sa ait
          internet sitesinde yer almaktadır. &Uuml;r&uuml;n&uuml;n temel
          &ouml;zellikleri hem &uuml;r&uuml;n&uuml;n ilanının yer aldığı ilgili
          sayfada, sipariş &ouml;zeti sayfasında ve aşağıda yer almaktadır.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">5.2. Listelenen ve sitede ilan edilen fiyatlar satış fiyatıdır. İlan
          edilen fiyatlar ve vaatler g&uuml;ncelleme yapılana ve değiştirilene
          kadar ge&ccedil;erlidir. S&uuml;reli olarak ilan edilen fiyatlar ise
          belirtilen s&uuml;re sonuna kadar ge&ccedil;erlidir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">5.3.S&ouml;zleşme konusu mal ya da hizmetin t&uuml;m vergiler
          d&acirc;hil satış fiyatı aşağıdaki tabloda g&ouml;sterilmiştir.
          <span style="background: yellow">Bu birim kar marjları 13.06.2022 tarihli fiyat listelerindeki
            marjlardır. Toplam siparişteki miktarın toleransı +/-
            10%&apos;dur.</span></span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&Uuml;r&uuml;n A&ccedil;ıklaması&nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;Adet&nbsp; &nbsp;&nbsp;Peşin Fiyatı&nbsp; &nbsp; &nbsp;Ara Toplam
          (KDV Dahil)</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">* www.buldans.com.tr internet sitesinin a&ccedil;ık pazar ve/veya diğer
          butiklerinden eş zamanlı olarak ger&ccedil;ekleştirilen alışverişlerde
          hak kazanılan toplam indirim tutarı, kargo bedeli ve taksit farkı tutarı
          birlikte yukarıdaki tabloda g&ouml;sterilmiştir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Teslimat Adresi&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;:&nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Teslim Edilecek Kişi&nbsp;&nbsp;:&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Satıcının Telefonu&nbsp; &nbsp; &nbsp;&nbsp;:&nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Fatura Adresi&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;&nbsp;:&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Sipariş Tarihi&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;&nbsp;:&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                    background: yellow;
                  ">İşbu siparişin verilmesi ile alıcı taraf, satın aldığı
          &uuml;r&uuml;nlerin bedellerinin vadesi hakkında ihtar edilmiş olur.
          Karşı taraf, vade tarihinde borcunu &ouml;demediği takdirde kendisine ek
          bir ihtar yapılması gerekmeksizin temerr&uuml;de d&uuml;şer ve satıcı
          temerr&uuml;t faizine hak kazanır. (TTK 1530/2)</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Teslim Şekli&nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;&nbsp;:Alıcıya Teslim</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                    background: yellow;
                  ">Etiket ve paketleme&nbsp; &nbsp;&nbsp;: Buldan&apos;s etiketli.
          &Ccedil;oklu paketleme.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">S&Ouml;Z KONUSU &Uuml;R&Uuml;N BEDELİ, BULDAN&rsquo;S ALICI
          G&Uuml;VENCESİ KAPSAMINDA SATICI ADINA, D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM
          SAN. VE TİC. A.Ş TARAFINDAN ALICI&rsquo;DAN TAHSİL EDİLMEKTEDİR. ALICI
          MALIN BEDELİNİ D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC.
          A.Ş&rsquo;YE &Ouml;DEMEKLE, &Uuml;R&Uuml;N BEDELİNİ SATICI&rsquo;YA
          &Ouml;DEMİŞ SAYILACAK VE BİR DAHA &Ouml;DEME
          Y&Uuml;K&Uuml;ML&Uuml;L&Uuml;Ğ&Uuml; ALTINA GİRMEYECEKTİR.
          ALICI&rsquo;NIN İLGİLİ MEVZUAT KAPSAMINDA İADE HAKLARI SAKLIDIR.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">6. &Ouml;DEME VE TESLİM ŞARTLARI</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Kargo Hari&ccedil; Toplam &Uuml;r&uuml;n Bedeli&nbsp; &nbsp;
          &nbsp;:&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Kargo &Uuml;creti&nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp;&nbsp;:&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Taksit Farkı&nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp;&nbsp;:&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Toplam Sipariş Bedeli&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;:&nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Sipariş Tarihi&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp;&nbsp;:&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                    background: yellow;
                  ">İşbu siparişin verilmesi ile alıcı taraf, satın aldığı
          &uuml;r&uuml;nlerin bedellerinin vadesi hakkında ihtar edilmiş olur.
          Karşı taraf, vade tarihinde borcunu &ouml;demediği takdirde kendisine ek
          bir ihtar yapılması gerekmeksizin temerr&uuml;de d&uuml;şer ve satıcı
          temerr&uuml;t faizine hak kazanır. (TTK 1530/2)</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&Ouml;deme Şekli ve Planı&nbsp;:<span style="background: yellow">%50&apos;si işbu s&ouml;zleşmenin
            tebliğine
            istinaden peşin ve kalan
            50% mal tesliminden 60 g&uuml;n sonra
            &hellip;&hellip;&hellip;...&hellip;&hellip;&hellip; tarihinde TL
            bazında banka havalesiyle peşin &ouml;denecektir.</span></span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                    background: yellow;
                  ">Vadesinde yapılmayan &ouml;demelerde, aylık % 3 faiz işletilir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                    background: yellow;
                  ">3500 TL ve &uuml;st&uuml; kargolarda Nakliye ve sigorta alıcıya
          aittir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                    background: yellow;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Teslim Şartları &uuml;r&uuml;n sayfasında belirtildiği şekilde
          uygulanacaktır.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Teslim Şartları: Alıcıya Teslim</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Teslim Alacak Kişiler&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;&nbsp;:&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">7. CAYMA HAKKI</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">7.1.ALICI hizmet ifasına ilişkin s&ouml;zleşmelerde s&ouml;zleşmenin
          kurulduğu g&uuml;nden, mal teslimine ilişkin s&ouml;zleşmelerde ise
          malın kendisine tesliminden itibaren, hi&ccedil;bir gerek&ccedil;e
          g&ouml;stermeksizin
          <span style="background: yellow">14 (on d&ouml;rt)</span> g&uuml;n
          i&ccedil;inde cayma hakkını kullanarak mal/hizmeti iade edebilir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">a) Cayma hakkına ilişkin s&uuml;renin hesabında tek sipariş konusu olup
          ayrı ayrı teslim edilen mallarda, ALICI&rsquo;nın veya ALICI tarafından
          belirlenen &uuml;&ccedil;&uuml;nc&uuml; kişinin son malı teslim aldığı
          g&uuml;n,</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">b) Birden fazla par&ccedil;adan oluşan mallarda, ALICI&rsquo;nın veya
          ALICI tarafından belirlenen &uuml;&ccedil;&uuml;nc&uuml; kişinin son
          par&ccedil;ayı teslim aldığı g&uuml;n,</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">c) Belirli bir s&uuml;re boyunca malın d&uuml;zenli tesliminin
          yapıldığı s&ouml;zleşmelerde, ALICI&rsquo;nın veya ALICI tarafından
          belirlenen &uuml;&ccedil;&uuml;nc&uuml; kişinin ilk malı teslim aldığı
          g&uuml;n esas alınır.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">7.2.ALICI, cayma hakkı kullanım bildirimini Websitesi &uuml;zerinden
          SATICI&rsquo;ya ulaştırır. SATICI, ALICI&rsquo;nın cayma beyanının
          kendisine ulaşmasından itibaren 14 (on d&ouml;rt) g&uuml;n i&ccedil;inde
          mal/hizmet bedelini iade etmekle y&uuml;k&uuml;ml&uuml;d&uuml;r.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">7.3. S&ouml;z konusu mal/hizmet bedeli ALICI&rsquo;nın satın alırken
          kullandığı &ouml;deme aracına uygun bir şekilde ALICI&rsquo;ya herhangi
          bir masraf veya y&uuml;k&uuml;ml&uuml;l&uuml;k getirmeden yapılır.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">7.4. ALICI, cayma hakkına ilişkin bildirimi SATICI veya D&Ouml;NMEZ EV
          TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş&rsquo;e y&ouml;nelttiği andan
          itibaren, 10 (on) g&uuml;n i&ccedil;inde malı SATICI&rsquo;ya geri
          g&ouml;nderir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">7.5. ALICI cayma s&uuml;resi i&ccedil;inde malı, işleyişine, teknik
          &ouml;zelliklerine ve kullanım talimatlarına uygun bir şekilde
          kullandığı takdirde meydana gelen değişiklik ve bozulmalardan sorumlu
          değildir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">7.6. ALICI iade edeceği mal/hizmeti &ouml;n bilgilendirme formunda
          belirtilen SATICI&rsquo;nın anlaşmalı kargo şirketi ile SATICI&rsquo;ya
          g&ouml;nderdiği s&uuml;rece, iade kargo bedeli SATICI&rsquo;ya aittir.
          İade i&ccedil;in ALICI&rsquo;nın bulunduğu yerde SATICI&rsquo;nın
          anlaşmalı kargo şirketi şubesi bulunmaması halinde ALICI herhangi bir
          kargo şirketiyle g&ouml;nderebilecektir, bu halde kargo bedeli
          ALICI&rsquo;ya aittir. ALICI&rsquo;nın iade edeceği malı &ouml;n
          bilgilendirme formunda belirtilen SATICI&rsquo;nın anlaşmalı kargo
          şirketi dışında bir kargo şirketi ile g&ouml;ndermesi halinde, iade
          kargo bedeli ve malın kargo s&uuml;recinde uğrayacağı hasardan SATICI
          sorumlu değildir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 0cm;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                    background: yellow;
                  ">T&uuml;keticinin, satıcının belirlediği taşıyıcı dışında başka bir
          taşıyıcı ile malın g&ouml;nderilmesini talep etmesi durumunda, malın
          ilgili taşıyıcıya tesliminden itibaren oluşabilecek kayıp ya da hasardan
          satıcı sorumlu değildir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">7.7. Mal ile beraber fatura da mevcut olması halinde, ilgili iade
          b&ouml;l&uuml;m&uuml; de doldurularak ve ALICI tarafından imzalanarak
          teslim edilmelidir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">7.8. Cayma hakkının kullanılmasıyla beraber ALICI ve SATICI arasındaki
          yan s&ouml;zleşmeler masraf, tazminat veya cezai şart &ouml;deme
          y&uuml;k&uuml;ml&uuml;l&uuml;ğ&uuml; olmaksızın sona erer.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">8. CAYMA HAKKININ KULLANILAMAYACAĞI HALLER</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">8.1. ALICI aşağıdaki s&ouml;zleşmelerde cayma hakkını kullanamaz:</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">a) Fiyatı finansal piyasalardaki dalgalanmalara bağlı olarak değişen ve
          SATICI veya D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş&rsquo;İN
          kontrol&uuml;nde olmayan mal veya hizmetlere ilişkin
          s&ouml;zleşmeler</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">b) T&uuml;keticinin istekleri veya kişisel ihtiya&ccedil;ları
          doğrultusunda hazırlanan mallara ilişkin s&ouml;zleşmeler</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">c) &Ccedil;abuk bozulabilen veya son kullanma tarihi ge&ccedil;ebilecek
          malların teslimine ilişkin s&ouml;zleşmeler</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&ccedil;) Tesliminden sonra ambalaj, bant, m&uuml;h&uuml;r, paket gibi
          koruyucu unsurları a&ccedil;ılmış olan mallardan; iadesi sağlık ve
          hijyen a&ccedil;ısından uygun olmayanların teslimine ilişkin
          s&ouml;zleşmeler.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">d) Tesliminden sonra başka &uuml;r&uuml;nlerle karışan ve doğası gereği
          ayrıştırılması m&uuml;mk&uuml;n olmayan mallara ilişkin
          s&ouml;zleşmeler.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">e) Malın tesliminden sonra ambalaj, bant, m&uuml;h&uuml;r, paket gibi
          koruyucu unsurları a&ccedil;ılmış olması halinde maddi ortamda sunulan
          kitap, dijital i&ccedil;erik ve bilgisayar sarf malzemelerine ilişkin
          s&ouml;zleşmeler.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">f) Abonelik s&ouml;zleşmesi kapsamında sağlananlar dışında gazete ve
          dergi gibi s&uuml;reli yayınların teslimine ilişkin
          s&ouml;zleşmeler.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">g) Belirli bir tarihte veya d&ouml;nemde yapılması gereken, konaklama,
          eşya taşıma, araba kiralama, yiyecek i&ccedil;ecek tedariki ve eğlence
          veya dinlenme amacıyla yapılan boş zamanın değerlendirilmesine ilişkin
          s&ouml;zleşmeler.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">ğ) Elektronik ortamda anında ifa edilen hizmetler ile ALICI&rsquo;ya
          anında teslim edilen gayri maddi mallara ilişkin s&ouml;zleşmeler.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">h) Cayma hakkı s&uuml;resi sona ermeden &ouml;nce, ALICI&rsquo;nın
          onayı ile ifasına başlanan hizmetlere ilişkin s&ouml;zleşmeler.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">S&ouml;zleşmeye konu Mal/Hizmet&apos;in Mesafeli S&ouml;zleşmeler
          Y&ouml;netmeliği&apos;nin uygulama alanı dışında bırakılmış olan
          (SATICI&rsquo;nın d&uuml;zenli teslimatları ile ALICI&rsquo;nın
          meskenine teslim edilen gıda maddelerinin, i&ccedil;eceklerin ya da
          diğer g&uuml;nl&uuml;k t&uuml;ketim maddeleri ile seyahat, konaklama,
          lokantacılık, eğlence sekt&ouml;r&uuml; gibi alanlarda hizmetler)
          Mal/Hizmet t&uuml;rlerinden m&uuml;teşekkil olması halinde ALICI ve
          SATICI arasındaki hukuki ilişkiye Mesafeli S&ouml;zleşmeler
          Y&ouml;netmeliği h&uuml;k&uuml;mleri uygulanamaması sebebiyle cayma
          hakkı kullanılamayacaktır.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">9. GENEL H&Uuml;K&Uuml;MLER</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">9.1. ALICI Platform &uuml;zerinden vereceği siparişlerde tek fatura ile
          aynı sepet i&ccedil;erisinde sipariş verebilecektir. SATICI,
          ALICI&rsquo;nın vereceği siparişler i&ccedil;in bir adet fatura
          kesecektir. ALICI, D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş
          tarafından kendisine bir adet fatura keserek kendisine
          g&ouml;nderilmesini kabul eder. Ş&uuml;pheye mahal bırakmamak bakımından
          belirtilmelidir ki, SATICI, ALICI&rsquo;nın aldığı &uuml;r&uuml;nlerin
          teslimatını mevzuattaki yasal s&uuml;re i&ccedil;erisinde kalmak
          koşuluyla farklı zamanlarda ger&ccedil;ekleştirebilecektir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">SATICI sattığı &uuml;r&uuml;nleri anlaşmalı kargo firmaları aracılığı
          ile ALICILAR&rsquo;a g&ouml;ndermekte ve teslim ettirmektedir. Kargo
          firmasının ALICI&rsquo;nın bulunduğu yerde şubesi olmaması halinde
          ALICI&rsquo;nın &Uuml;r&uuml;n&rsquo;&uuml; kargo firmasının SATICI
          tarafından bildirilen yakın bir diğer şubesinden teslim alması
          gerekmektedir. İnternet sitesinde &quot;tahmini teslimat tarihi&quot;
          şeklinde belirtilen &uuml;r&uuml;nlerin, teslimat tarihi tahmini olarak
          belirtilmiş olup bu ifade herhangi bir taahh&uuml;t
          i&ccedil;ermemektedir. Bu &uuml;r&uuml;nler mevzuatta belirtildiği
          &uuml;zere en ge&ccedil; 30 g&uuml;n i&ccedil;erisinde ALICI&rsquo;ya
          teslim edilecektir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">9.2. Genel olarak aksi belirtilmediği s&uuml;rece teslimat masrafları
          (kargo &uuml;creti vb.) ALICI&rsquo;ya aittir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">9.3. S&ouml;zleşme konusu &uuml;r&uuml;n, yasal 30 (otuz)
          g&uuml;nl&uuml;k s&uuml;reyi aşmamak koşulu ile her bir &uuml;r&uuml;n
          i&ccedil;in ALICI&rsquo;nın yerleşim yerinin uzaklığına bağlı olarak
          yasal s&uuml;resi i&ccedil;inde ALICI veya g&ouml;sterdiği adresteki
          kişi/kuruluşa, SATICI&rsquo;nın anlaşmalı olduğu kargo firması
          tarafından teslim edilir.&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                    background: yellow;
                  ">9.4.İşbu s&ouml;zleşme ile satıcı, sipariş konusu &uuml;r&uuml;nlerini
          &uuml;retime başlayacak, ham madde teminini yapacak ve &uuml;retim
          planlamasını bu sipariş doğduğunda g&uuml;ncelleyecektir.&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                    background: yellow;
                  ">ALICI, sipariş konusu &uuml;r&uuml;nleri almaktan hi&ccedil;bir koşulda
          vazge&ccedil;emeyecek, alıcı siparişin durumunda ve adetlerinde,
          modellerde değişiklik yapamayacak s&ouml;zleşmeden d&ouml;nemeyecek, bu
          maddeye aykırı davranması halinde ya da ilerleyen s&uuml;re&ccedil;te
          siparişin bir kısmını almaktan vazge&ccedil;mesi halinde verilen
          kaparonun iade edilmeyecek ve hi&ccedil;bir şekilde geri
          isteyenemeyecektir. Ayrıca bu durumda, satıcının doğacak t&uuml;m
          zararlarını ALICI karşılayacaktır.&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                    background: yellow;
                  ">9.5. Malın teslimi sonrasında, gizli ayıp haricinde, malda bir eksiklik
          ya da ayıp bulunması durumunda, alıcı 15 g&uuml;n i&ccedil;erisinde bu
          durumu satıcıya bildirecektir. Teslimden itibaren 15 g&uuml;n sonrasında
          teslim edilen &uuml;r&uuml;nler hi&ccedil;bir gerek&ccedil;e ile iade
          edilemeyecek, gizli ayıp haricinde ayıp, hata ihbarında
          bulunulamayacaktır.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">9.6. &Uuml;r&uuml;nler&rsquo;in, teslimatı anında ALICI&rsquo;nın
          bizatihi adresinde bulunmaması durumunda, SATICI edimini tam ve eksiksiz
          olarak yerine getirmiş olarak kabul edilecektir. Adreste teslim alacak
          kimsenin olmaması durumunda kargo firması ile temas kurarak
          &uuml;r&uuml;nlerin sevkiyatını takip etmek ALICI&rsquo;nın sorumluluğu
          olacaktır. &Uuml;r&uuml;n, ALICI&rsquo;dan başka bir kişi/kuruluşa
          teslim edilecek ise, teslim edilecek kişi/kuruluşun adresinde
          bulunmamasından veya teslimatı kabul etmemesinden SATICI sorumlu
          tutulamaz. Bu hallerde ALICI&rsquo;nın &Uuml;r&uuml;n&apos;&uuml;
          ge&ccedil; teslim almasından kaynaklanan her t&uuml;rl&uuml; zarar ile
          &Uuml;r&uuml;n&apos;&uuml;n kargo şirketinde beklemiş olması ve/veya
          kargonun SATICI&apos;ya iade edilmesinden dolayı oluşan giderler
          ALICI&rsquo;ya aittir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">9.7. ALICI, &Uuml;r&uuml;n&apos;&uuml; teslim aldığı anda kontrol
          etmekle ve &uuml;r&uuml;nde kargodan kaynaklanan bir sorun
          g&ouml;rd&uuml;ğ&uuml;nde, &uuml;r&uuml;n&uuml; kabul etmemekle ve kargo
          firması yetkilisine tutanak tutturmakla sorumludur. Aksi halde SATICI
          sorumluluk kabul etmeyecektir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">9.8. ALICI, SATICI tarafından aksi yazılı &ouml;ng&ouml;r&uuml;lmemiş
          ise, &Uuml;r&uuml;n&apos;&uuml; teslim almadan &ouml;nce bedelini
          tamamen &ouml;demiş olması gerekir. Peşin satışlarda teslimattan
          &ouml;nce &Uuml;r&uuml;n bedeli SATICI&rsquo;ya tamamen &ouml;denmediği,
          taksitli satışlarda vadesi gelen taksit tutarı tediye edilmediği
          takdirde, SATICI tek taraflı olarak s&ouml;zleşmeyi iptal edebilir ve
          &Uuml;r&uuml;n&apos;&uuml; teslim etmeyebilir. &Uuml;r&uuml;n teslimatı
          sonrasında herhangi bir sebepten dolayı, işlem yapılan kredi kartının
          ait olduğu banka/finans kuruluşunun &Uuml;r&uuml;n bedelini
          SATICI&apos;ya &ouml;dememesi halinde, &Uuml;r&uuml;n en ge&ccedil; 3
          g&uuml;n i&ccedil;inde ALICI tarafından t&uuml;m giderleri
          ALICI&rsquo;ya ait olmak &uuml;zere SATICI&apos;ya iade edilir.
          SATICI&apos;nın iadeyi kabul etmeksizin &Uuml;r&uuml;n bedeli alacağını
          takip dahil diğer t&uuml;m akdi-kanuni hakları ayrıca ve her halde
          saklıdır. Herhangi bir sebeple banka ve/veya finans kuruluşu tarafından
          başarısız kodu g&ouml;nderilen ancak banka ve/veya finans kuruluşu
          tarafından SATICI&rsquo;ya yapılan &ouml;demelere ilişkin
          SATICI&rsquo;nın herhangi bir sorumluluğu bulunmayacaktır.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">9.9. &Uuml;r&uuml;n&apos;&uuml;n normal satış/teslimat koşulları
          dışında olağan&uuml;st&uuml; durumlar (hava muhalefeti, yoğun trafik,
          deprem, sel, yangın gibi) nedeni ile yasal 30 g&uuml;nl&uuml;k s&uuml;re
          zarfında teslim edilememesi halinde SATICI teslimat ile ilgili olarak
          ALICI&rsquo;yı bilgilendirir. Bu durumda ALICI siparişi iptal edebilir,
          benzer bir &uuml;r&uuml;n sipariş edebilir veya olağan&uuml;st&uuml;
          durum sonuna kadar bekleyebilir.
          <span style="background: yellow">M&uuml;cbir sebep halleri olan yangın,sel, deprem, salgın
            hastalık,doğal afetler kaynaklı işletmede ve tedarik zincirinde
            işlerin kısmen ve tamamiyle yapılamaması halinde teslimat tarihleri
            revize edilebilir.</span></span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">9.10. Sipariş iptallerinde &uuml;r&uuml;n bedeli tahsil edilmiş ise
          ALICI&rsquo;ya iade edilir. Kredi kartlı &ouml;demelerde iade işlemi de
          ALICI kredi kartına iade sureti ile yapılır ve &Uuml;r&uuml;n tutarı,
          siparişin ALICI tarafından iptal edilmesinden sonra ilgili bankaya iade
          edilir; bu tutarın Bankaya iadesinden sonra ALICI hesaplarına yansıması
          tamamen Banka işlem s&uuml;reci ile ilgili olduğundan, ALICI olası
          gecikmeler i&ccedil;in SATICI&rsquo;nın herhangi bir şekilde
          m&uuml;dahalede bulunmasının ve sorumluluk &uuml;stlenmesinin
          m&uuml;mk&uuml;n olamayacağını şimdiden kabul eder. (Bankaların iadeyi
          ALICI hesabına yansıtma işlemleri genellikle 3 (&uuml;&ccedil;) haftayı
          bulabilmektedir).</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">9.11. SATICI olağan&uuml;st&uuml; durumlar dışında haklı bir nedenle
          s&ouml;zleşme konusu &uuml;r&uuml;nlerin tedarik edilemeyeceğinin
          anlaşılması halinde durumu &ouml;ğrenmesinden itibaren 3
          (&uuml;&ccedil;) g&uuml;n i&ccedil;inde ALICI&rsquo;yı bilgilendirerek
          onayını almak sureti ile eşit kalite ve fiyatta başka bir mal/hizmeti
          tedarik edebilir ve S&ouml;zleşme konusu taahh&uuml;d&uuml;n&uuml; bu
          suretle yerine getirmiş sayılır. ALICI&rsquo;nın onay vermediği hallerde
          sipariş iptaline ilişkin h&uuml;k&uuml;mler uygulanır.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">10. KİŞİSEL VERİLERİN KORUNMASI, TİCARİ ELEKTRONİK İLETİ VE FİKRİ-SINAİ
          HAKLAR İLE İLGİLİ KURALLAR ŞARTLAR</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">10.1. 6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında kişisel
          veri olarak tanımlanabilecek ALICI&rsquo;ya ait ad, soyad, e-posta
          adresi, T.C. Kimlik numarası, demografik veriler, mali veriler vb.
          bilgiler;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&bull; sipariş almak, &uuml;r&uuml;n ve hizmetleri sunmak,
          &uuml;r&uuml;n ve hizmetleri geliştirmek, sistemsel sorunların
          &ccedil;&ouml;z&uuml;m&uuml;, &ouml;deme işlemlerini
          ger&ccedil;ekleştirmek, -&ouml;nceden onay verilmesi halinde-
          siparişler, &uuml;r&uuml;nler ve hizmetler hakkında pazarlama
          faaliyetlerinde kullanılmak, ALICI&rsquo;ya ait bilgilerin
          g&uuml;ncellenmesinde ve &uuml;yeliklerin y&ouml;netimi ve
          s&uuml;rd&uuml;r&uuml;lmesi ile ALICI ile SATICI arasında kurulan
          mesafeli satış s&ouml;zleşmesi ve sair s&ouml;zleşmelerin ifası amacıyla
          ve 3. kişilerin teknik, lojistik ve benzeri diğer işlevlerinin SATICI
          tarafından sağlanabilmesi i&ccedil;in yukarıda sayılan verileri
          D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş &nbsp;ve
          &uuml;&ccedil;&uuml;nc&uuml; kişi ve/veya kuruluşlar tarafından
          s&uuml;resiz/s&uuml;reli kaydedilebilir, yazılı/manyetik arşivlerde
          muhafaza edilebilir, kullanılabilir, g&uuml;ncellenebilir,
          paylaşılabilir, transfer olunabilir ve sair suretler ile
          işlenebilir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">10.2. ALICILAR&rsquo;a, y&uuml;r&uuml;rl&uuml;kteki mevzuata uygun
          şekilde, her t&uuml;rl&uuml; &uuml;r&uuml;n ve hizmetlere ilişkin
          tanıtım, reklam, iletişim, promosyon, satış ve pazarlama amacıyla, kredi
          kartı ve &uuml;yelik bilgilendirme, işlem, uygulamaları i&ccedil;in
          D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş -Buldan&rsquo;s
          tarafından SMS/kısa mesaj, anlık bildirim, otomatik arama, bilgisayar,
          telefon, e-posta/mail, faks, diğer elektronik iletişim ara&ccedil;ları
          ile ticari elektronik iletişimler yapılabilir, ALICI kendisine ticari
          elektronik iletiler g&ouml;nderilmesini kabul etmiştir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">10.3. ALICI tarafından Platform&rsquo;a girilen bilgilerin ve
          işlemlerin g&uuml;venliği i&ccedil;in gerekli &ouml;nlemler, D&Ouml;NMEZ
          EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş &nbsp;tarafındaki kendi sistem
          altyapısında, bilgi ve işlemin mahiyetine g&ouml;re
          g&uuml;n&uuml;m&uuml;z teknik imk&acirc;nları
          &ouml;l&ccedil;&uuml;s&uuml;nde alınmıştır. Bununla beraber, s&ouml;z
          konusu bilgiler ALICI&rsquo;ya ait cihazlardan girildiğinden ALICI
          tarafından korunmaları ve ilgisiz kişilerce erişilememesi i&ccedil;in,
          vir&uuml;s ve benzeri zararlı uygulamalara ilişkin olanlar d&acirc;hil,
          gerekli tedbirlerin alınması sorumluluğu ALICI&rsquo;ya aittir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">10.4. ALICI, D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş
          &rsquo;de belirtilen iletişim kanallarından ulaşarak veri
          kullanımı-işlenmelerini ve/veya iletişimleri her zaman i&ccedil;in
          durdurulmasını talep edebilir. ALICI&rsquo;nın bu husustaki a&ccedil;ık
          bildirimine g&ouml;re, kişisel veri işlemleri ve/veya tarafına
          iletişimler yasal azami s&uuml;re i&ccedil;inde durdurulur; ayrıca
          dilerse, hukuken muhafazası gerekenler ve/veya m&uuml;mk&uuml;n olanlar
          haricindeki bilgileri, veri kayıt sisteminden silinir ya da kimliği
          belli olmayacak bi&ccedil;imde anonim hale getirilir. ALICI isterse
          kişisel verilerinin işlenmesi ile ilgili işlemler, aktarıldığı kişiler,
          eksik veya yanlış olması halinde d&uuml;zeltilmesi, d&uuml;zeltilen
          bilgilerin ilgili &uuml;&ccedil;&uuml;nc&uuml; kişilere bildirilmesi,
          verilerin silinmesi veya yok edilmesi, otomatik sistemler ile analiz
          edilmesi sureti ile kendisi aleyhine bir sonucun ortaya &ccedil;ıkmasına
          itiraz, verilerin kanuna aykırı olarak işlenmesi sebebi ile zarara
          uğrama halinde giderilmesi gibi konularda D&Ouml;NMEZ EV TEKSTİLİ VE
          GİYİM SAN. VE TİC. A.Ş &rsquo;e her zaman başvurabilir ve bilgi
          alabilir. S&ouml;z konusu başvurular incelenerek yasal s&uuml;resi
          i&ccedil;erisinde ALICI&rsquo;ya mevzuatta &ouml;ng&ouml;r&uuml;len
          s&uuml;relerde d&ouml;n&uuml;ş yapılacaktır.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">10.5. Platform&rsquo;a ait her t&uuml;rl&uuml; bilgi ve i&ccedil;erik
          ile bunların d&uuml;zenlenmesi, revizyonu ve kısmen/tamamen kullanımı
          konusunda; SATICI&apos;nın anlaşmasına g&ouml;re diğer
          &uuml;&ccedil;&uuml;nc&uuml; şahıslara ait olanlar hari&ccedil;;
          t&uuml;m fikri-sınai haklar ve m&uuml;lkiyet hakları D&Ouml;NMEZ EV
          TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş &nbsp;Şirketi&rsquo;ne aittir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">10.6. Platform&rsquo;dan ulaşılan diğer sitelerde kendilerine ait
          gizlilik-g&uuml;venlik politikaları ve kullanım şartları
          ge&ccedil;erlidir, oluşabilecek ihtilaflar ile menfi neticelerinden
          D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş &nbsp;sorumlu
          değildir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">11. UYUŞMAZLIKLARIN &Ccedil;&Ouml;Z&Uuml;M&Uuml;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">Yukarıdaki bilgiler uzaktan iletişim ara&ccedil;larına uygun olarak ve
          iyi niyet ilkeleri &ccedil;er&ccedil;evesinde ergin olmayanlar ile
          ayırtım g&uuml;c&uuml;nden yoksun veya kısıtlı erginleri koruyacak
          şekilde ticari ama&ccedil;larla verilmiştir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                    background: yellow;
                  ">11.1. İşbu &Ouml;n Bilgilendirmenin uygulanmasında ve işbu
          s&ouml;zleşmeden doğacak uyuşmazlıklarda yahut &ccedil;ekişmesiz işlerde
          işlerde Denizli Mahkemeleri ve İcra Daireleri yetkilidir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 0cm;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">11.2.İşbu Mesafeli Satış S&ouml;zleşmesi&apos;nin uygulanmasında,
          Ticaret Bakanlığınca ilan edilen değere kadar T&uuml;ketici Hakem
          Heyetleri ile T&uuml;ketici Mahkemeleri yetkilidir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 0cm;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 0cm;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                    background: yellow;
                  ">11.3. 6502 Sayılı T&uuml;keticinin Korunması Hakkında Kanun&apos;un 68.
          maddesinin 1. fıkrasında belirtilen alt ve &uuml;st limitler
          doğrultusunda t&uuml;ketici talepleri hakkında il&ccedil;e/il
          t&uuml;ketici hakem heyetleri yetkilidir.</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
      <p style="
                  margin-top: 0cm;
                  margin-right: 0cm;
                  margin-bottom: 8pt;
                  margin-left: 0cm;
                  line-height: 107%;
                  font-size: 15px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                ">
        <span style="
                    font-size: 16px;
                    line-height: 107%;
                    font-family: 'Times New Roman', serif;
                  ">&nbsp;</span>
      </p>
    </div>
    <div v-else>
      <div>
        <div>
          <p>&Ouml;N BİLGİLENDİRME FORMU &nbsp;</p>
        </div>
        <div>
          <p>1. TARAFLAR VE KONU&nbsp;</p>
        </div>
        <div>
          <p>İşbu &Ouml;n Bilgilendirme&nbsp;Formu&rsquo;nun&nbsp;konusu, ALICI ile SATICI arasındaki mesafeli
            s&ouml;zleşmeye ilişkin T&uuml;keticilerin Korunması Hakkındaki Kanun ve Mesafeli S&ouml;zleşmeler
            Y&ouml;netmeliği h&uuml;k&uuml;mleri uyarınca bilgilendirilmesidir. Ayrıca Mesafeli S&ouml;zleşmeler
            Y&ouml;netmeliği uyarınca 5/1 a, d, g ve h maddelerindeki hususlara ilişkin bilgiler işbu &Ouml;n
            bilgilendirme&nbsp;Formu&rsquo;nda&nbsp;yer almaktadır. ALICI &ouml;n bilgilendirme formu ve mesafeli satış
            s&ouml;zleşmesine ilişkin bilgileri &uuml;yeliğinin bağlı olduğu &ldquo;Hesabım&rdquo; sayfasından takip
            edebilecek ve siparişine ilişkin verdiği bilgileri &ldquo;Hesabım&rdquo; sayfasından değiştirebilecektir.
            &Ouml;n bilgilendirme formu ve mesafeli satış s&ouml;zleşmesi {{ sistemAdres }} tarafından kayıt altına
            alınmakta olup, ALICI dilediği zaman &ldquo;Hesabım&rdquo; sayfasından metinlere ulaşım
            sağlayabilecektir.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>2. TANIMLAR&nbsp;</p>
        </div>
        <div>
          <p>İşbu s&ouml;zleşmenin uygulanmasında ve yorumlanmasında aşağıda yazılı terimler karşılarındaki yazılı
            a&ccedil;ıklamaları ifade edeceklerdir.&nbsp;</p>
        </div>
        <div>
          <p>ALICI          &nbsp;  :Bir&nbsp;mal veya hizmeti ticari veya mesleki olmayan ama&ccedil;larla edinen,
            kullanan veya yararlanan ger&ccedil;ek ya da t&uuml;zel kişiyi,&nbsp;</p>
        </div>
        <div>
          <p>Bakan           &nbsp;  :Ticaret&nbsp;Bakanı&rsquo;nı,&nbsp;</p>
        </div>
        <div>
          <p>Bakanlık       &nbsp; :Ticaret&nbsp;Bakanlığı&rsquo;nı,&nbsp;</p>
        </div>
        <div>
          <p>{{ firma }}:SATICI&rsquo;lar&rsquo;ın&nbsp;&uuml;r&uuml;n ve
            hizmet sunduğu&nbsp;Platform&rsquo;u&nbsp;sağlayan aracı hizmet sağlayıcısı olan&nbsp;{{ firma }}- &nbsp;</p>
        </div>
        <div>
          <p>Hizmet                     &nbsp;  :Bir&nbsp;&uuml;cret veya menfaat karşılığında yapılan ya da yapılması
            taahh&uuml;t edilen mal sağlama dışındaki her t&uuml;rl&uuml; t&uuml;ketici işleminin konusu,&nbsp;</p>
        </div>
        <div>
          <p>Kanun          &nbsp;  :T&uuml;keticinin&nbsp;Korunması Hakkında Kanun&rsquo;u,&nbsp;</p>
        </div>
        <div>
          <p>Platform       &nbsp;  :&nbsp;{{ firma }}&nbsp;e ait
            {{ sistemAdres }} adlı internet sitesini ve mobil uygulamasını,&nbsp;</p>
        </div>
        <div>
          <p>SATICI       &nbsp;  :Kamu&nbsp;t&uuml;zel kişileri de dahil olmak &uuml;zere ticari veya mesleki
            ama&ccedil;larla t&uuml;keticiye mal sunan ya da mal sunanın adına ya da hesabına hareket eden ve
            S&ouml;zleşme&rsquo;nin 6. maddesinde bilgileri bulunan ger&ccedil;ek ve/veya t&uuml;zel kişiyi,&nbsp;</p>
        </div>
        <div>
          <p>Sipariş&nbsp;Veren  :Bir&nbsp;mal veya hizmeti&nbsp;{{ firma }};e ait {{ sistemAdres }} adlı internet sitesi
            veya mobil uygulaması &uuml;zerinden talep eden
            ger&ccedil;ek ya da t&uuml;zel kişiyi,&nbsp;</p>
        </div>
        <div>
          <p>S&ouml;zleşme       &nbsp; :SATICI&nbsp;ve ALICI arasında akdedilen işbu&nbsp;S&ouml;zleşme&rsquo;yi,&nbsp;
          </p>
        </div>
        <div>
          <p>Taraflar         &nbsp; :SATICI&nbsp;ve&nbsp;ALICI&rsquo;yı,&nbsp;</p>
        </div>
        <div>
          <p>&Uuml;r&uuml;n veya&nbsp;&Uuml;r&uuml;nler   &nbsp;  :Alışverişe&nbsp;konu olan taşınır eşya, tatil
            ama&ccedil;lı taşınan tekstil &uuml;r&uuml;nleri ile ev dekorasyonu ve benzeri her t&uuml;rl&uuml;
            &uuml;r&uuml;nleri, ifade eder.&nbsp;</p>
        </div>
        <div>
          <p>Y&ouml;netmelik              &nbsp;  :Mesafeli&nbsp;Satışlar Y&ouml;netmeliği&rsquo;ni,&nbsp;</p>
        </div>
        <div>
          <p>3. SATICI BİLGİLERİ&nbsp;</p>
        </div>
        <div>
          <p>Satıcı İsim/Unvanı   &nbsp;  :&nbsp;{{ firma }} &nbsp;</p>
        </div>
        <div>
          <p>Satıcının A&ccedil;ık&nbsp;Adresi :&nbsp;Ovaak&ccedil;a&nbsp;Merkez Mah. İstanbul Cad. No:567-A/B Osmangazi
            Bursa&nbsp;</p>
        </div>
        <div>
          <p>Satıcının&nbsp;Telefonu      :444&nbsp;7 005&nbsp;</p>
        </div>
        <div>
          <p>Satıcı&nbsp;Mersis&nbsp;No       &nbsp; :           &nbsp;</p>
        </div>
        <div>
          <p>Satıcı E-Posta :           {{ mailAdres }}</p>
        </div>
        <div>
          <p>Alıcının İade Halinde Malı Satıcıya G&ouml;ndereceği Kargo&nbsp;Şirketi   &nbsp; :           İade&nbsp;kodu
            alındığında tarafınıza bilgilendirilen kargo firmasıyla iadenizi g&ouml;nderebilirsiniz.&nbsp;</p>
        </div>
        <div>
          <p>4. ARACI HİZMET&nbsp;SAĞLAYICI&nbsp;&nbsp;{{ firma }}&nbsp;&nbsp;
          </p>
        </div>
        <div>
          <p>BİLGİLERİ&nbsp;</p>
        </div>
        <div>
          <p>Aracı Hizmet Sağlayıcı&nbsp;Unvan       &nbsp;  :           {{ firma }}-&nbsp;(&ldquo;{{ firma
          }}&rdquo;)&apos;e ait
            [{{ sistemAdres }}]&nbsp;</p>
        </div>
        <div>
          <p>Aracı Hizmet Sağlayıcı&nbsp;Mersis&nbsp;No &nbsp;  :           &nbsp;</p>
        </div>
        <div>
          <p>Aracı Hizmet Sağlayıcısı A&ccedil;ık&nbsp;Adresi          :Ovaak&ccedil;a&nbsp;Merkez Mah. İstanbul Cad.
            No:567-A/B Osmangazi Bursa&nbsp;</p>
        </div>
        <div>
          <p>Aracı Hizmet Sağlayıcı&nbsp;Numarası   &nbsp; :           444&nbsp;7 005&nbsp;</p>
        </div>
        <div>
          <p>Aracı Hizmet Sağlayıcı E-posta&nbsp;Adresi     &nbsp;  :{{ mailAdres }}</p>
        </div>
        <div>
          <p>5. S&Ouml;ZLEŞME KONUSU MAL VE HİZMETİN TEMEL NİTELİKLERİ ve FİYATI (KDV&nbsp;DAHİL&nbsp;DEĞİL)&nbsp;</p>
        </div>
        <div>
          <p>5.1. Malın/&Uuml;r&uuml;n/&Uuml;r&uuml;nlerin/Hizmetin temel &ouml;zelliklerini (t&uuml;r&uuml;, miktarı,
            marka/modeli, rengi, adedi)&nbsp;{{ firma }}&nbsp;ait internet
            sitesinde yer almaktadır. &Uuml;r&uuml;n&uuml;n temel &ouml;zellikleri hem &uuml;r&uuml;n&uuml;n ilanının yer
            aldığı ilgili sayfada, sipariş &ouml;zeti sayfasında ve aşağıda yer almaktadır.&nbsp;</p>
        </div>
        <div>
          <p>5.2. Listelenen ve sitede ilan edilen fiyatlar satış fiyatıdır. İlan edilen fiyatlar ve vaatler
            g&uuml;ncelleme yapılana ve değiştirilene kadar ge&ccedil;erlidir. S&uuml;reli olarak ilan edilen fiyatlar ise
            belirtilen s&uuml;re sonuna kadar ge&ccedil;erlidir.&nbsp;</p>
        </div>
        <div>
          <p>5.3.S&ouml;zleşme konusu mal ya da hizmetin t&uuml;m vergiler d&acirc;hil satış fiyatı aşağıdaki tabloda
            g&ouml;sterilmiştir. Bu birim kar&nbsp;marjları&nbsp;13.06.2022 tarihli fiyat listelerindeki marjlardır.
            Toplam siparişteki miktarın toleransı +/- 10%&apos;dur.&nbsp;</p>
        </div>
        <div>
          <p>&Uuml;r&uuml;n A&ccedil;ıklaması         Adet    Peşin Fiyatı     Ara Toplam
            (KDV&nbsp;Dahil&nbsp;Değil)&nbsp;</p>
        </div>
        <div>
          <p>* {{ sistemAdres }} internet sitesinin a&ccedil;ık pazar ve/veya diğer butiklerinden eş zamanlı olarak
            ger&ccedil;ekleştirilen alışverişlerde hak kazanılan toplam indirim tutarı, kargo bedeli ve taksit farkı
            tutarı birlikte yukarıdaki tabloda g&ouml;sterilmiştir.&nbsp;</p>
        </div>
        <div>
          <p>Teslimat&nbsp;Adresi       &nbsp;  :           &nbsp;</p>
        </div>
        <div>
          <p>Teslim Edilecek&nbsp;Kişi  :           &nbsp;</p>
        </div>
        <div>
          <p>Satıcının&nbsp;Telefonu   &nbsp;  :           &nbsp;</p>
        </div>
        <div>
          <p>Fatura&nbsp;Adresi           &nbsp;  :           &nbsp;</p>
        </div>
        <div>
          <p>Sipariş&nbsp;Tarihi           &nbsp;  :           &nbsp;</p>
        </div>
        <div>
          <p>İşbu siparişin verilmesi ile alıcı taraf, satın aldığı &uuml;r&uuml;nlerin bedellerinin vadesi hakkında ihtar
            edilmiş olur. Karşı taraf, vade tarihinde borcunu &ouml;demediği takdirde kendisine ek bir ihtar yapılması
            gerekmeksizin temerr&uuml;de d&uuml;şer ve satıcı temerr&uuml;t faizine hak kazanır. (TTK 1530/2)&nbsp;</p>
        </div>
        <div>
          <p>Teslim&nbsp;Şekli            &nbsp;  :Alıcıya&nbsp;Teslim&nbsp;</p>
        </div>
        <div>
          <p>Etiket ve&nbsp;paketleme &nbsp;  :&nbsp;&Ccedil;oklu&nbsp;paketleme.&nbsp;</p>
        </div>
        <div>
          <p>S&Ouml;Z KONUSU &Uuml;R&Uuml;N BEDELİ,&nbsp;{{ firma }}&nbsp;ALICI G&Uuml;VENCESİ KAPSAMINDA SATICI
            ADINA,&nbsp;{{ firma }} TARAFINDAN ALICI&rsquo;DAN TAHSİL EDİLMEKTEDİR. ALICI MALIN
            BEDELİNİ&nbsp;{{ firma }}&rsquo;YE&nbsp;&Ouml;DEMEKLE,
            &Uuml;R&Uuml;N BEDELİNİ SATICI&rsquo;YA &Ouml;DEMİŞ SAYILACAK VE BİR DAHA &Ouml;DEME
            Y&Uuml;K&Uuml;ML&Uuml;L&Uuml;Ğ&Uuml; ALTINA GİRMEYECEKTİR. ALICI&rsquo;NIN İLGİLİ MEVZUAT KAPSAMINDA İADE
            HAKLARI SAKLIDIR.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>6. &Ouml;DEME VE TESLİM ŞARTLARI&nbsp;</p>
        </div>
        <div>
          <p>Kargo Hari&ccedil; Toplam &Uuml;r&uuml;n&nbsp;Bedeli   &nbsp; :           &nbsp;</p>
        </div>
        <div>
          <p>Kargo&nbsp;&Uuml;creti                                    &nbsp;  :           &nbsp;</p>
        </div>
        <div>
          <p>Taksit&nbsp;Farkı                                     &nbsp;  :           &nbsp;</p>
        </div>
        <div>
          <p>Toplam Sipariş&nbsp;Bedeli                    &nbsp;  :           &nbsp;</p>
        </div>
        <div>
          <p>Sipariş&nbsp;Tarihi                                   &nbsp;  :           &nbsp;</p>
        </div>
        <div>
          <p>İşbu siparişin verilmesi ile alıcı taraf, satın aldığı &uuml;r&uuml;nlerin bedellerinin vadesi hakkında ihtar
            edilmiş olur. Karşı taraf, vade tarihinde borcunu &ouml;demediği takdirde kendisine ek bir ihtar yapılması
            gerekmeksizin temerr&uuml;de d&uuml;şer ve satıcı temerr&uuml;t faizine hak kazanır. (TTK 1530/2)&nbsp;</p>
        </div>
        <div>
          <p>&Ouml;deme Şekli ve&nbsp;Planı :%50&apos;si işbu s&ouml;zleşmenin tebliğine istinaden peşin ve kalan 50% mal
            tesliminden 60 g&uuml;n sonra&nbsp;&hellip;&hellip;&hellip;...&hellip;&hellip;&hellip;&nbsp;tarihinde&nbsp;TL
            bazında banka havalesiyle peşin &ouml;denecektir.&nbsp;</p>
        </div>
        <div>
          <p>Vadesinde yapılmayan &ouml;demelerde, aylık&nbsp;% 3&nbsp;faiz işletilir.&nbsp;</p>
        </div>
        <div>
          <p>3500 TL ve &uuml;st&uuml; kargolarda Nakliye ve sigorta alıcıya aittir.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>Teslim Şartları &uuml;r&uuml;n sayfasında belirtildiği şekilde uygulanacaktır.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>Teslim Şartları: Alıcıya Teslim&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>Teslim Alacak&nbsp;Kişiler         &nbsp;  : &nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>7. CAYMA HAKKI&nbsp;</p>
        </div>
        <div>
          <p>7.1.ALICI hizmet ifasına ilişkin s&ouml;zleşmelerde s&ouml;zleşmenin kurulduğu g&uuml;nden, mal teslimine
            ilişkin s&ouml;zleşmelerde ise malın kendisine tesliminden itibaren, hi&ccedil;bir gerek&ccedil;e
            g&ouml;stermeksizin 14 (on d&ouml;rt) g&uuml;n i&ccedil;inde cayma hakkını kullanarak mal/hizmeti iade
            edebilir.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>a) Cayma hakkına ilişkin s&uuml;renin hesabında tek sipariş konusu olup ayrı ayrı teslim edilen
            mallarda,&nbsp;ALICI&rsquo;nın&nbsp;veya ALICI tarafından belirlenen &uuml;&ccedil;&uuml;nc&uuml; kişinin son
            malı teslim aldığı g&uuml;n,&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>b) Birden fazla par&ccedil;adan oluşan mallarda,&nbsp;ALICI&rsquo;nın&nbsp;veya ALICI tarafından belirlenen
            &uuml;&ccedil;&uuml;nc&uuml; kişinin son par&ccedil;ayı teslim aldığı g&uuml;n,&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>c) Belirli bir s&uuml;re boyunca malın d&uuml;zenli tesliminin yapıldığı
            s&ouml;zleşmelerde,&nbsp;ALICI&rsquo;nın&nbsp;veya ALICI tarafından belirlenen &uuml;&ccedil;&uuml;nc&uuml;
            kişinin ilk malı teslim aldığı g&uuml;n esas alınır.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>7.2.ALICI, cayma hakkı kullanım
            bildirimini&nbsp;Websitesi&nbsp;&uuml;zerinden&nbsp;SATICI&rsquo;ya&nbsp;ulaştırır.
            SATICI,&nbsp;ALICI&rsquo;nın&nbsp;cayma beyanının kendisine ulaşmasından itibaren 14 (on d&ouml;rt) g&uuml;n
            i&ccedil;inde mal/hizmet bedelini iade etmekle y&uuml;k&uuml;ml&uuml;d&uuml;r.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>7.3. S&ouml;z konusu mal/hizmet bedeli&nbsp;ALICI&rsquo;nın&nbsp;satın alırken kullandığı &ouml;deme aracına
            uygun bir şekilde&nbsp;ALICI&rsquo;ya&nbsp;herhangi bir masraf veya y&uuml;k&uuml;ml&uuml;l&uuml;k getirmeden
            yapılır.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>7.4. ALICI, cayma hakkına ilişkin bildirimi SATICI veya&nbsp;{{ firma }} ye&nbsp;y&ouml;nelttiği andan
            itibaren, 10 (on) g&uuml;n i&ccedil;inde
            malı&nbsp;SATICI&rsquo;ya&nbsp;geri g&ouml;nderir.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>7.5. ALICI cayma s&uuml;resi i&ccedil;inde malı, işleyişine, teknik &ouml;zelliklerine ve kullanım
            talimatlarına uygun bir şekilde kullandığı takdirde meydana gelen değişiklik ve bozulmalardan sorumlu
            değildir.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>7.6. ALICI iade edeceği mal/hizmeti &ouml;n bilgilendirme formunda
            belirtilen&nbsp;SATICI&rsquo;nın&nbsp;anlaşmalı kargo şirketi ile&nbsp;SATICI&rsquo;ya&nbsp;g&ouml;nderdiği
            s&uuml;rece, iade kargo bedeli&nbsp;SATICI&rsquo;ya&nbsp;aittir. İade
            i&ccedil;in&nbsp;ALICI&rsquo;nın&nbsp;bulunduğu yerde&nbsp;SATICI&rsquo;nın&nbsp;anlaşmalı kargo şirketi
            şubesi bulunmaması halinde ALICI herhangi bir kargo şirketiyle g&ouml;nderebilecektir, bu halde kargo
            bedeli&nbsp;ALICI&rsquo;ya&nbsp;aittir.&nbsp;ALICI&rsquo;nın&nbsp;iade edeceği malı &ouml;n bilgilendirme
            formunda belirtilen&nbsp;SATICI&rsquo;nın&nbsp;anlaşmalı kargo şirketi dışında bir kargo şirketi ile
            g&ouml;ndermesi halinde, iade kargo bedeli ve malın kargo s&uuml;recinde uğrayacağı hasardan SATICI sorumlu
            değildir.&nbsp;</p>
        </div>
        <div>
          <p>T&uuml;keticinin, satıcının belirlediği taşıyıcı dışında başka bir taşıyıcı ile malın g&ouml;nderilmesini
            talep etmesi durumunda, malın ilgili taşıyıcıya tesliminden itibaren oluşabilecek kayıp ya da hasardan satıcı
            sorumlu değildir.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>7.7. Mal ile beraber fatura da mevcut olması halinde, ilgili iade b&ouml;l&uuml;m&uuml; de doldurularak ve
            ALICI tarafından imzalanarak teslim edilmelidir.&nbsp;</p>
        </div>
        <div>
          <p>7.8. Cayma hakkının kullanılmasıyla beraber ALICI ve SATICI arasındaki yan s&ouml;zleşmeler masraf, tazminat
            veya cezai şart &ouml;deme y&uuml;k&uuml;ml&uuml;l&uuml;ğ&uuml; olmaksızın sona erer.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>8. CAYMA HAKKININ KULLANILAMAYACAĞI HALLER&nbsp;</p>
        </div>
        <div>
          <p>8.1. ALICI aşağıdaki s&ouml;zleşmelerde cayma hakkını kullanamaz:&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>a) Fiyatı finansal piyasalardaki dalgalanmalara bağlı olarak değişen ve SATICI
            veya&nbsp;{{ firma }}&rsquo;İN&nbsp;kontrol&uuml;nde olmayan
            mal veya hizmetlere ilişkin s&ouml;zleşmeler&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>b) T&uuml;keticinin istekleri veya kişisel ihtiya&ccedil;ları doğrultusunda hazırlanan mallara ilişkin
            s&ouml;zleşmeler&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>c) &Ccedil;abuk bozulabilen veya son kullanma tarihi ge&ccedil;ebilecek malların teslimine ilişkin
            s&ouml;zleşmeler&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>&ccedil;) Tesliminden sonra ambalaj, bant, m&uuml;h&uuml;r, paket gibi koruyucu unsurları a&ccedil;ılmış olan
            mallardan; iadesi sağlık ve&nbsp;hijyen&nbsp;a&ccedil;ısından uygun olmayanların teslimine ilişkin
            s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>d) Tesliminden sonra başka &uuml;r&uuml;nlerle karışan ve doğası gereği ayrıştırılması m&uuml;mk&uuml;n
            olmayan mallara ilişkin s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>e) Malın tesliminden sonra ambalaj, bant, m&uuml;h&uuml;r, paket gibi koruyucu unsurları a&ccedil;ılmış
            olması halinde maddi ortamda sunulan kitap, dijital i&ccedil;erik ve bilgisayar sarf malzemelerine ilişkin
            s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>f) Abonelik s&ouml;zleşmesi kapsamında sağlananlar dışında gazete ve dergi gibi s&uuml;reli yayınların
            teslimine ilişkin s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>g) Belirli bir tarihte veya d&ouml;nemde yapılması gereken, konaklama, eşya taşıma, araba kiralama, yiyecek
            i&ccedil;ecek tedariki ve eğlence veya dinlenme amacıyla yapılan boş zamanın değerlendirilmesine ilişkin
            s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>ğ) Elektronik ortamda anında ifa edilen hizmetler ile&nbsp;ALICI&rsquo;ya&nbsp;anında teslim edilen gayri
            maddi mallara ilişkin s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>h) Cayma hakkı s&uuml;resi sona ermeden &ouml;nce,&nbsp;ALICI&rsquo;nın&nbsp;onayı ile ifasına başlanan
            hizmetlere ilişkin s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>S&ouml;zleşmeye konu Mal/Hizmet&apos;in&nbsp;Mesafeli S&ouml;zleşmeler Y&ouml;netmeliği&apos;nin uygulama
            alanı dışında bırakılmış olan (SATICI&rsquo;nın&nbsp;d&uuml;zenli teslimatları
            ile&nbsp;ALICI&rsquo;nın&nbsp;meskenine teslim edilen gıda maddelerinin, i&ccedil;eceklerin ya da diğer
            g&uuml;nl&uuml;k t&uuml;ketim maddeleri ile seyahat, konaklama, lokantacılık, eğlence sekt&ouml;r&uuml; gibi
            alanlarda hizmetler) Mal/Hizmet t&uuml;rlerinden&nbsp;m&uuml;teşekkil olması halinde ALICI ve SATICI
            arasındaki hukuki ilişkiye Mesafeli S&ouml;zleşmeler Y&ouml;netmeliği h&uuml;k&uuml;mleri uygulanamaması
            sebebiyle cayma hakkı kullanılamayacaktır.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>9. GENEL H&Uuml;K&Uuml;MLER&nbsp;</p>
        </div>
        <div>
          <p>9.1. ALICI Platform &uuml;zerinden vereceği siparişlerde tek fatura ile aynı sepet i&ccedil;erisinde sipariş
            verebilecektir. SATICI,&nbsp;ALICI&rsquo;nın&nbsp;vereceği siparişler i&ccedil;in bir adet fatura kesecektir.
            ALICI,&nbsp;{{ firma }}&nbsp;tarafından kendisine bir adet fatura
            keserek kendisine g&ouml;nderilmesini kabul eder. Ş&uuml;pheye mahal bırakmamak bakımından belirtilmelidir ki,
            SATICI,&nbsp;ALICI&rsquo;nın&nbsp;aldığı &uuml;r&uuml;nlerin teslimatını mevzuattaki yasal s&uuml;re
            i&ccedil;erisinde kalmak koşuluyla farklı zamanlarda ger&ccedil;ekleştirebilecektir.&nbsp;</p>
        </div>
        <div>
          <p>SATICI sattığı &uuml;r&uuml;nleri anlaşmalı kargo firmaları aracılığı
            ile&nbsp;ALICILAR&rsquo;a&nbsp;g&ouml;ndermekte ve teslim ettirmektedir. Kargo
            firmasının&nbsp;ALICI&rsquo;nın&nbsp;bulunduğu yerde şubesi olmaması
            halinde&nbsp;ALICI&rsquo;nın&nbsp;&Uuml;r&uuml;n&rsquo;&uuml; kargo firmasının SATICI tarafından bildirilen
            yakın bir diğer şubesinden teslim alması gerekmektedir. İnternet sitesinde &quot;tahmini teslimat tarihi&quot;
            şeklinde belirtilen &uuml;r&uuml;nlerin, teslimat tarihi tahmini olarak belirtilmiş olup bu ifade herhangi bir
            taahh&uuml;t i&ccedil;ermemektedir. Bu &uuml;r&uuml;nler mevzuatta belirtildiği &uuml;zere en ge&ccedil; 30
            g&uuml;n i&ccedil;erisinde&nbsp;ALICI&rsquo;ya&nbsp;teslim edilecektir.&nbsp;</p>
        </div>
        <div>
          <p>9.2. Genel olarak aksi belirtilmediği s&uuml;rece teslimat masrafları (kargo &uuml;creti
            vb.)&nbsp;ALICI&rsquo;ya&nbsp;aittir.&nbsp;</p>
        </div>
        <div>
          <p>9.3. S&ouml;zleşme konusu &uuml;r&uuml;n, yasal 30 (otuz) g&uuml;nl&uuml;k s&uuml;reyi aşmamak koşulu ile her
            bir &uuml;r&uuml;n i&ccedil;in&nbsp;ALICI&rsquo;nın&nbsp;yerleşim yerinin uzaklığına bağlı olarak yasal
            s&uuml;resi i&ccedil;inde ALICI veya g&ouml;sterdiği adresteki
            kişi/kuruluşa,&nbsp;SATICI&rsquo;nın&nbsp;anlaşmalı olduğu kargo firması tarafından teslim edilir. &nbsp;</p>
        </div>
        <div>
          <p>9.4.İşbu s&ouml;zleşme ile satıcı, sipariş konusu &uuml;r&uuml;nlerini &uuml;retime başlayacak, ham madde
            teminini yapacak ve &uuml;retim planlamasını bu sipariş doğduğunda g&uuml;ncelleyecektir. &nbsp;</p>
        </div>
        <div>
          <p>ALICI, sipariş konusu &uuml;r&uuml;nleri almaktan hi&ccedil;bir koşulda vazge&ccedil;emeyecek, alıcı
            siparişin durumunda ve adetlerinde, modellerde değişiklik yapamayacak s&ouml;zleşmeden d&ouml;nemeyecek, bu
            maddeye aykırı davranması halinde ya da ilerleyen s&uuml;re&ccedil;te siparişin bir kısmını almaktan
            vazge&ccedil;mesi halinde verilen kaparonun iade edilmeyecek ve hi&ccedil;bir şekilde
            geri&nbsp;isteyenemeyecektir. Ayrıca bu durumda, satıcının doğacak t&uuml;m zararlarını ALICI
            karşılayacaktır. &nbsp;</p>
        </div>
        <div>
          <p>9.5. Malın teslimi sonrasında, gizli ayıp haricinde, malda bir eksiklik ya da ayıp bulunması durumunda, alıcı
            15 g&uuml;n i&ccedil;erisinde bu durumu satıcıya bildirecektir. Teslimden itibaren 15 g&uuml;n sonrasında
            teslim edilen &uuml;r&uuml;nler hi&ccedil;bir gerek&ccedil;e ile iade edilemeyecek, gizli ayıp haricinde ayıp,
            hata ihbarında bulunulamayacaktır.&nbsp;</p>
        </div>
        <div>
          <p>9.6.&nbsp;&Uuml;r&uuml;nler&rsquo;in, teslimatı anında&nbsp;ALICI&rsquo;nın&nbsp;bizatihi adresinde
            bulunmaması durumunda, SATICI edimini tam ve eksiksiz olarak yerine getirmiş olarak kabul edilecektir. Adreste
            teslim alacak kimsenin olmaması durumunda kargo firması ile temas kurarak &uuml;r&uuml;nlerin sevkiyatını
            takip etmek&nbsp;ALICI&rsquo;nın&nbsp;sorumluluğu olacaktır. &Uuml;r&uuml;n,&nbsp;ALICI&rsquo;dan&nbsp;başka
            bir kişi/kuruluşa teslim edilecek ise, teslim edilecek kişi/kuruluşun adresinde bulunmamasından veya teslimatı
            kabul etmemesinden SATICI sorumlu tutulamaz. Bu hallerde&nbsp;ALICI&rsquo;nın&nbsp;&Uuml;r&uuml;n&apos;&uuml;
            ge&ccedil; teslim almasından kaynaklanan her t&uuml;rl&uuml; zarar ile &Uuml;r&uuml;n&apos;&uuml;n kargo
            şirketinde beklemiş olması ve/veya kargonun&nbsp;SATICI&apos;ya&nbsp;iade edilmesinden dolayı oluşan
            giderler&nbsp;ALICI&rsquo;ya&nbsp;aittir.&nbsp;</p>
        </div>
        <div>
          <p>9.7. ALICI, &Uuml;r&uuml;n&apos;&uuml; teslim aldığı anda kontrol etmekle ve &uuml;r&uuml;nde kargodan
            kaynaklanan bir sorun g&ouml;rd&uuml;ğ&uuml;nde, &uuml;r&uuml;n&uuml; kabul etmemekle ve kargo firması
            yetkilisine tutanak tutturmakla sorumludur. Aksi halde SATICI sorumluluk kabul etmeyecektir.&nbsp;</p>
        </div>
        <div>
          <p>9.8. ALICI, SATICI tarafından aksi yazılı &ouml;ng&ouml;r&uuml;lmemiş ise, &Uuml;r&uuml;n&apos;&uuml; teslim
            almadan &ouml;nce bedelini tamamen &ouml;demiş olması gerekir. Peşin satışlarda teslimattan &ouml;nce
            &Uuml;r&uuml;n bedeli&nbsp;SATICI&rsquo;ya&nbsp;tamamen &ouml;denmediği, taksitli satışlarda vadesi gelen
            taksit tutarı tediye&nbsp;edilmediği takdirde, SATICI tek taraflı olarak s&ouml;zleşmeyi iptal edebilir ve
            &Uuml;r&uuml;n&apos;&uuml; teslim etmeyebilir. &Uuml;r&uuml;n teslimatı sonrasında herhangi bir sebepten
            dolayı, işlem yapılan kredi kartının ait olduğu banka/finans kuruluşunun &Uuml;r&uuml;n
            bedelini&nbsp;SATICI&apos;ya&nbsp;&ouml;dememesi halinde, &Uuml;r&uuml;n en ge&ccedil; 3 g&uuml;n
            i&ccedil;inde ALICI tarafından t&uuml;m giderleri&nbsp;ALICI&rsquo;ya&nbsp;ait olmak
            &uuml;zere&nbsp;SATICI&apos;ya&nbsp;iade edilir.&nbsp;SATICI&apos;nın&nbsp;iadeyi kabul etmeksizin
            &Uuml;r&uuml;n bedeli alacağını takip&nbsp;dahil&nbsp;diğer t&uuml;m akdi-kanuni hakları ayrıca ve her halde
            saklıdır. Herhangi bir sebeple banka ve/veya finans kuruluşu tarafından başarısız kodu g&ouml;nderilen ancak
            banka ve/veya finans kuruluşu tarafından&nbsp;SATICI&rsquo;ya&nbsp;yapılan &ouml;demelere
            ilişkin&nbsp;SATICI&rsquo;nın&nbsp;herhangi bir sorumluluğu bulunmayacaktır.&nbsp;</p>
        </div>
        <div>
          <p>9.9. &Uuml;r&uuml;n&apos;&uuml;n normal satış/teslimat koşulları dışında olağan&uuml;st&uuml; durumlar (hava
            muhalefeti, yoğun trafik, deprem, sel, yangın gibi) nedeni ile yasal 30 g&uuml;nl&uuml;k s&uuml;re zarfında
            teslim edilememesi halinde SATICI teslimat ile ilgili olarak&nbsp;ALICI&rsquo;yı&nbsp;bilgilendirir. Bu
            durumda ALICI siparişi iptal edebilir, benzer bir &uuml;r&uuml;n sipariş edebilir veya olağan&uuml;st&uuml;
            durum sonuna kadar bekleyebilir. M&uuml;cbir sebep halleri olan&nbsp;yangın,sel, deprem,
            salgın&nbsp;hastalık,doğal&nbsp;afetler kaynaklı işletmede ve tedarik zincirinde işlerin kısmen
            ve&nbsp;tamamiyle&nbsp;yapılamaması halinde teslimat tarihleri revize edilebilir.&nbsp;</p>
        </div>
        <div>
          <p>9.10. Sipariş iptallerinde &uuml;r&uuml;n bedeli tahsil edilmiş ise&nbsp;ALICI&rsquo;ya&nbsp;iade
            edilir.&nbsp;Kredi kartlı &ouml;demelerde iade işlemi de ALICI kredi kartına iade sureti ile yapılır ve
            &Uuml;r&uuml;n tutarı, siparişin ALICI tarafından iptal edilmesinden sonra ilgili bankaya iade edilir; bu
            tutarın Bankaya iadesinden sonra ALICI hesaplarına yansıması tamamen Banka işlem s&uuml;reci ile ilgili
            olduğundan, ALICI olası gecikmeler i&ccedil;in&nbsp;SATICI&rsquo;nın&nbsp;herhangi bir şekilde m&uuml;dahalede
            bulunmasının ve sorumluluk &uuml;stlenmesinin m&uuml;mk&uuml;n olamayacağını şimdiden kabul
            eder.&nbsp;(Bankaların iadeyi ALICI hesabına yansıtma işlemleri genellikle 3 (&uuml;&ccedil;) haftayı
            bulabilmektedir).&nbsp;</p>
        </div>
        <div>
          <p>9.11. SATICI olağan&uuml;st&uuml; durumlar dışında haklı bir nedenle s&ouml;zleşme konusu &uuml;r&uuml;nlerin
            tedarik edilemeyeceğinin anlaşılması halinde durumu &ouml;ğrenmesinden itibaren 3 (&uuml;&ccedil;) g&uuml;n
            i&ccedil;inde&nbsp;ALICI&rsquo;yı&nbsp;bilgilendirerek onayını almak sureti ile eşit kalite ve fiyatta başka
            bir mal/hizmeti tedarik edebilir ve S&ouml;zleşme konusu taahh&uuml;d&uuml;n&uuml; bu suretle yerine getirmiş
            sayılır.&nbsp;ALICI&rsquo;nın&nbsp;onay vermediği hallerde sipariş iptaline ilişkin h&uuml;k&uuml;mler
            uygulanır.&nbsp;</p>
        </div>
        <div>
          <p>10. KİŞİSEL VERİLERİN KORUNMASI, TİCARİ ELEKTRONİK İLETİ VE FİKRİ-SINAİ HAKLAR İLE İLGİLİ KURALLAR
            ŞARTLAR&nbsp;</p>
        </div>
        <div>
          <p>10.1. 6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında kişisel veri olarak
            tanımlanabilecek&nbsp;ALICI&rsquo;ya&nbsp;ait ad,&nbsp;soyad, e-posta adresi, T.C. Kimlik numarası, demografik
            veriler, mali veriler vb. bilgiler;&nbsp;</p>
        </div>
        <div>
          <p>&bull; sipariş almak, &uuml;r&uuml;n ve hizmetleri sunmak, &uuml;r&uuml;n ve hizmetleri geliştirmek,
            sistemsel sorunların &ccedil;&ouml;z&uuml;m&uuml;, &ouml;deme işlemlerini ger&ccedil;ekleştirmek,
            -&ouml;nceden onay verilmesi halinde- siparişler, &uuml;r&uuml;nler ve hizmetler hakkında pazarlama
            faaliyetlerinde kullanılmak,&nbsp;ALICI&rsquo;ya&nbsp;ait bilgilerin g&uuml;ncellenmesinde ve &uuml;yeliklerin
            y&ouml;netimi ve s&uuml;rd&uuml;r&uuml;lmesi ile ALICI ile SATICI arasında kurulan mesafeli satış
            s&ouml;zleşmesi ve sair s&ouml;zleşmelerin ifası amacıyla ve 3. kişilerin teknik, lojistik ve benzeri diğer
            işlevlerinin SATICI tarafından sağlanabilmesi i&ccedil;in yukarıda sayılan
            verileri&nbsp;{{ firma }} ve&nbsp;&uuml;&ccedil;&uuml;nc&uuml; kişi ve/veya kuruluşlar tarafından
            s&uuml;resiz/s&uuml;reli
            kaydedilebilir, yazılı/manyetik arşivlerde muhafaza edilebilir, kullanılabilir, g&uuml;ncellenebilir,
            paylaşılabilir, transfer olunabilir ve sair suretler ile işlenebilir.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>10.2.&nbsp;ALICILAR&rsquo;a, y&uuml;r&uuml;rl&uuml;kteki mevzuata uygun şekilde, her t&uuml;rl&uuml;
            &uuml;r&uuml;n ve hizmetlere ilişkin tanıtım, reklam, iletişim,&nbsp;promosyon, satış ve pazarlama amacıyla,
            kredi kartı ve &uuml;yelik bilgilendirme, işlem, uygulamaları i&ccedil;in&nbsp;{{ firma }} tarafından SMS/kısa
            mesaj, anlık bildirim, otomatik arama, bilgisayar, telefon,
            e-posta/mail, faks, diğer elektronik iletişim ara&ccedil;ları ile ticari elektronik iletişimler yapılabilir,
            ALICI kendisine ticari elektronik iletiler g&ouml;nderilmesini kabul etmiştir.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>10.3. ALICI tarafından&nbsp;Platform&rsquo;a&nbsp;girilen bilgilerin ve işlemlerin g&uuml;venliği i&ccedil;in
            gerekli &ouml;nlemler,&nbsp;{{ firma }} tarafındaki kendi sistem
            altyapısında, bilgi ve işlemin mahiyetine g&ouml;re g&uuml;n&uuml;m&uuml;z teknik imk&acirc;nları
            &ouml;l&ccedil;&uuml;s&uuml;nde alınmıştır. Bununla beraber, s&ouml;z konusu
            bilgiler&nbsp;ALICI&rsquo;ya&nbsp;ait cihazlardan girildiğinden ALICI tarafından korunmaları ve ilgisiz
            kişilerce erişilememesi i&ccedil;in, vir&uuml;s ve benzeri zararlı uygulamalara ilişkin olanlar d&acirc;hil,
            gerekli tedbirlerin alınması sorumluluğu&nbsp;ALICI&rsquo;ya&nbsp;aittir.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>10.4. ALICI,&nbsp;{{ firma }}&rsquo;de&nbsp;belirtilen
            iletişim kanallarından ulaşarak veri kullanımı-işlenmelerini ve/veya iletişimleri her zaman i&ccedil;in
            durdurulmasını talep edebilir.&nbsp;ALICI&rsquo;nın&nbsp;bu husustaki a&ccedil;ık bildirimine g&ouml;re,
            kişisel veri işlemleri ve/veya tarafına iletişimler yasal azami s&uuml;re i&ccedil;inde durdurulur; ayrıca
            dilerse, hukuken muhafazası gerekenler ve/veya m&uuml;mk&uuml;n olanlar haricindeki bilgileri, veri kayıt
            sisteminden silinir ya da kimliği belli olmayacak bi&ccedil;imde anonim hale getirilir.&nbsp;ALICI isterse
            kişisel verilerinin işlenmesi ile ilgili işlemler, aktarıldığı kişiler, eksik veya yanlış olması halinde
            d&uuml;zeltilmesi, d&uuml;zeltilen bilgilerin ilgili &uuml;&ccedil;&uuml;nc&uuml; kişilere bildirilmesi,
            verilerin silinmesi veya yok edilmesi, otomatik sistemler ile analiz edilmesi sureti ile kendisi aleyhine bir
            sonucun ortaya &ccedil;ıkmasına itiraz, verilerin kanuna aykırı olarak işlenmesi sebebi ile zarara uğrama
            halinde giderilmesi gibi konularda&nbsp;{{ firma }}&nbsp;&rsquo;e
            her zaman başvurabilir ve bilgi alabilir.&nbsp;S&ouml;z konusu başvurular incelenerek yasal s&uuml;resi
            i&ccedil;erisinde&nbsp;ALICI&rsquo;ya&nbsp;mevzuatta &ouml;ng&ouml;r&uuml;len s&uuml;relerde d&ouml;n&uuml;ş
            yapılacaktır.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>10.5.&nbsp;Platform&rsquo;a&nbsp;ait her t&uuml;rl&uuml; bilgi ve i&ccedil;erik ile bunların
            d&uuml;zenlenmesi,&nbsp;revizyonu&nbsp;ve kısmen/tamamen kullanımı
            konusunda;&nbsp;SATICI&apos;nın&nbsp;anlaşmasına g&ouml;re diğer &uuml;&ccedil;&uuml;nc&uuml; şahıslara ait
            olanlar hari&ccedil;; t&uuml;m fikri-sınai haklar ve m&uuml;lkiyet hakları&nbsp;{{ firma }}
            ne&nbsp;aittir.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>10.6.&nbsp;Platform&rsquo;dan&nbsp;ulaşılan diğer sitelerde kendilerine ait gizlilik-g&uuml;venlik
            politikaları ve kullanım şartları ge&ccedil;erlidir, oluşabilecek ihtilaflar ile menfi
            neticelerinden&nbsp;{{ firma }}&nbsp; sorumlu&nbsp;değildir.&nbsp;
          </p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>11. UYUŞMAZLIKLARIN &Ccedil;&Ouml;Z&Uuml;M&Uuml;&nbsp;</p>
        </div>
        <div>
          <p>Yukarıdaki bilgiler uzaktan iletişim ara&ccedil;larına uygun olarak ve iyi niyet ilkeleri
            &ccedil;er&ccedil;evesinde ergin olmayanlar ile ayırtım g&uuml;c&uuml;nden yoksun veya kısıtlı erginleri
            koruyacak şekilde ticari ama&ccedil;larla verilmiştir.&nbsp;</p>
        </div>
        <div>
          <p>11.1. İşbu &Ouml;n Bilgilendirmenin uygulanmasında ve işbu s&ouml;zleşmeden doğacak uyuşmazlıklarda yahut
            &ccedil;ekişmesiz işlerde&nbsp;işlerde&nbsp;Bursa&nbsp;Mahkemeleri ve İcra Daireleri yetkilidir.&nbsp;</p>
        </div>
        <div>
          <p>11.2.İşbu Mesafeli Satış S&ouml;zleşmesi&apos;nin uygulanmasında, Ticaret Bakanlığınca ilan edilen değere
            kadar T&uuml;ketici Hakem Heyetleri ile T&uuml;ketici Mahkemeleri yetkilidir.&nbsp;</p>
        </div>
        <div>
          <p> &nbsp;</p>
        </div>
        <div>
          <p>11.3. 6502 Sayılı T&uuml;keticinin Korunması Hakkında Kanun&apos;un 68. maddesinin 1. fıkrasında belirtilen
            alt ve &uuml;st limitler doğrultusunda t&uuml;ketici talepleri hakkında il&ccedil;e/il t&uuml;ketici hakem
            heyetleri yetkilidir.&nbsp;</p>
        </div>
        <div>
          <p>&nbsp;</p>
        </div>
      </div>
    </div>
    </vx-card>
   

  </div>
</template>
<script>
import Store from "../../store/store";
import state from "../../store/state";
import userJson from "../../../public/user.json";
export default {
  data() {
    return {
      firma: userJson.firma,
      sistemAdres: userJson.url,
      mailAdres: userJson.mail,
      logoUrl: "",
    }
  },
  created() {
    this.logoUrl = userJson.userLogo;
  }
}
</script>